<template>
    <div :class="cls">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 837.21 788.46" >
            <defs>

                <linearGradient id="New_Gradient_Swatch_23" x1="562.08" y1="318.82" x2="567.22" y2="328.45" gradientTransform="matrix(-1, 0, 0, 1, 1271.65, 0)" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stop-color="#27c09b"/>
                    <stop offset="0.53" stop-color="#008f6f"/>
                    <stop offset="1" stop-color="#006551"/>
                </linearGradient>
                <linearGradient id="New_Gradient_Swatch_23-2" x1="684.62" y1="324.21" x2="700.86" y2="354.62" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_23-3" x1="634.72" y1="321.99" x2="693.22" y2="384.26" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_23-4" x1="546.29" y1="318.12" x2="564.8" y2="337.82" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_23-5" x1="592.1" y1="324.68" x2="599.96" y2="339.4" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_23-6" x1="567.94" y1="323.61" x2="596.26" y2="353.75" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_23-7" x1="635.28" y1="332.95" x2="646.03" y2="353.09" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_23-8" x1="602.22" y1="331.49" x2="640.97" y2="372.73" xlink:href="#New_Gradient_Swatch_23"/>
                <radialGradient id="radial-gradient" cx="431.76" cy="591.5" fx="587.9199530352342" fy="266.1409673401513" r="360.89" gradientTransform="translate(0 354.9) scale(1 0.4)" gradientUnits="userSpaceOnUse">
                    <stop offset="0.78" stop-color="#002141" stop-opacity="0"/>
                    <stop offset="1" stop-color="#51d5c2"/>
                </radialGradient>
                <radialGradient id="radial-gradient-2" cx="431.76" cy="597.27" r="292.89" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stop-color="#002141" stop-opacity="0"/>
                    <stop offset="1" stop-color="#5ad6df"/>
                </radialGradient>
                <radialGradient id="radial-gradient-3" cx="408.83" cy="671.11" r="292.97" gradientTransform="translate(5.09 -182.65) scale(1.05 1.19)" xlink:href="#radial-gradient-2"/>
                <radialGradient id="radial-gradient-4" cx="430.5" cy="527.65" fx="556.751848873554" fy="264.60367517425925" r="291.78" gradientTransform="translate(0 316.59) scale(1 0.4)" gradientUnits="userSpaceOnUse">
                    <stop offset="0.7" stop-color="#002141" stop-opacity="0"/>
                    <stop offset="1" stop-color="#6c92c2" stop-opacity="0.9"/>
                </radialGradient>
                <linearGradient id="未命名的渐变_33" x1="75.22" y1="355.07" x2="461.08" y2="355.07" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stop-color="#fff" stop-opacity="0.5"/>
                    <stop offset="1" stop-color="#fff"/>
                </linearGradient>
                <linearGradient id="未命名的渐变_31" x1="348.24" y1="415.78" x2="85.55" y2="415.78" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stop-color="#55b0ff"/>
                    <stop offset="1" stop-color="#2ae4ff" stop-opacity="0.2"/>
                </linearGradient>
                <linearGradient id="未命名的渐变_31-2" x1="348.24" y1="426.88" x2="85.55" y2="426.88" xlink:href="#未命名的渐变_31"/>
                <linearGradient id="未命名的渐变_31-3" x1="348.24" y1="437.66" x2="85.55" y2="437.66" xlink:href="#未命名的渐变_31"/>
                <linearGradient id="未命名的渐变_31-4" x1="348.24" y1="448.76" x2="85.55" y2="448.76" xlink:href="#未命名的渐变_31"/>
                <linearGradient id="未命名的渐变_31-5" x1="348.24" y1="459.7" x2="85.55" y2="459.7" xlink:href="#未命名的渐变_31"/>
                <linearGradient id="未命名的渐变_31-6" x1="348.24" y1="470.81" x2="85.55" y2="470.81" xlink:href="#未命名的渐变_31"/>
                <linearGradient id="未命名的渐变_23" x1="123.54" y1="275.83" x2="284.94" y2="275.83" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stop-color="#feff5f"/>
                    <stop offset="0.53" stop-color="#c0ff7f"/>
                    <stop offset="1" stop-color="#fffb3d" stop-opacity="0.2"/>
                </linearGradient>
                <linearGradient id="New_Gradient_Swatch_23-9" x1="857.59" y1="472.5" x2="855.21" y2="487.05" gradientTransform="matrix(-0.96, -0.27, -0.27, 0.96, 1651.02, 91.35)" xlink:href="#New_Gradient_Swatch_23"/>
                <clipPath id="clip-path">
                    <path class="cls-1" d="M694.77,333.63l1.8.74,1.64.67h.07l-3.44-1.41h-.08Z"/>
                </clipPath>
                <linearGradient id="New_Gradient_Swatch_23-10" x1="851.8" y1="488.11" x2="855.54" y2="488.11" gradientTransform="matrix(-0.96, -0.27, -0.27, 0.96, 1651.02, 91.35)" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_23-11" x1="856.92" y1="478.75" x2="852.8" y2="487.49" gradientTransform="matrix(-0.96, -0.27, -0.27, 0.96, 1651.02, 91.35)" xlink:href="#New_Gradient_Swatch_23"/>
                <clipPath id="clip-path-2">
                    <path class="cls-2" d="M700.24,326.9l3.1,2.11a3.27,3.27,0,0,0,.35.21l.39.17.42.12.45.07a4.64,4.64,0,0,0,1.94-.24,6.36,6.36,0,0,0,1.89-1,7.59,7.59,0,0,0,1.58-1.69,7.25,7.25,0,0,0,1-2.17,6.22,6.22,0,0,0,.21-1.21,5.14,5.14,0,0,0,0-1.12,4.35,4.35,0,0,0-.28-1,3.66,3.66,0,0,0-.48-.83l-2.52-3.23a3.78,3.78,0,0,1,.51.89,4.57,4.57,0,0,1,.29,1.08,5.64,5.64,0,0,1,0,1.23,7,7,0,0,1-.23,1.34,8.49,8.49,0,0,1-1.11,2.44A8.77,8.77,0,0,1,706,326a7.12,7.12,0,0,1-2,1.2,4.85,4.85,0,0,1-2.07.32,4,4,0,0,1-.48-.07,3.66,3.66,0,0,1-.44-.12,3.48,3.48,0,0,1-.41-.17A3.37,3.37,0,0,1,700.24,326.9Z"/>
                </clipPath>
                <linearGradient id="New_Gradient_Swatch_23-13" x1="843.85" y1="474.18" x2="848.9" y2="483.64" gradientTransform="matrix(-0.96, -0.27, -0.27, 0.96, 1651.02, 91.35)" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_23-14" x1="566.72" y1="354.71" x2="573.45" y2="354.71" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_23-15" x1="564.86" y1="349.07" x2="564.99" y2="333.8" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_23-16" x1="563.42" y1="357.12" x2="571.59" y2="329.25" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_23-17" x1="560.24" y1="366.09" x2="569.94" y2="366.09" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_23-18" x1="562.2" y1="353.59" x2="535.05" y2="380.75" xlink:href="#New_Gradient_Swatch_23"/>
                <clipPath id="clip-path-3">
                    <path class="cls-5" d="M706,335.74l2.83,1.42a1.28,1.28,0,0,0,.24,0,2.35,2.35,0,0,0,.57-.1,3.44,3.44,0,0,0,.83-.39,5.38,5.38,0,0,0,1-.85l1.35-1.44,2.47-2.63,2.51-2.67,1.32-1.4-1.83-2.78-1.46,1.61-2.77,3.06-2.71,3-1.48,1.63a6.1,6.1,0,0,1-1.11,1,3.81,3.81,0,0,1-.9.45,2.41,2.41,0,0,1-.61.13A1.31,1.31,0,0,1,706,335.74Z"/>
                </clipPath>
                <linearGradient id="New_Gradient_Swatch_23-20" x1="826.69" y1="471.19" x2="844.93" y2="490.6" gradientTransform="matrix(-0.96, -0.27, -0.27, 0.96, 1651.02, 91.35)" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_23-21" x1="545.56" y1="309.19" x2="555.91" y2="332.12" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_15" x1="856.22" y1="469.01" x2="863.53" y2="519.01" gradientTransform="matrix(-0.96, -0.27, -0.27, 0.96, 1651.02, 91.35)" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stop-color="#a0fbe4"/>
                    <stop offset="0.53" stop-color="#4aedc8"/>
                    <stop offset="1" stop-color="#06cea9"/>
                </linearGradient>
                <linearGradient id="New_Gradient_Swatch_15-2" x1="849.05" y1="470.23" x2="856.3" y2="519.82" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_15-3" x1="838.78" y1="471.74" x2="846.03" y2="521.33" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_15-4" x1="559.05" y1="316.46" x2="566.3" y2="366.05" gradientTransform="matrix(-1, 0, 0, 1, 1271.65, 0)" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_23-22" x1="559.5" y1="357.61" x2="570.97" y2="354.83" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_15-5" x1="562.32" y1="336.97" x2="551.23" y2="308.25" gradientTransform="matrix(-1, 0, 0, 1, 1271.65, 0)" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_15-6" x1="572.22" y1="333.15" x2="561.13" y2="304.42" gradientTransform="matrix(-1, 0, 0, 1, 1271.65, 0)" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_15-7" x1="570.77" y1="333.71" x2="559.68" y2="304.99" gradientTransform="matrix(-1, 0, 0, 1, 1271.65, 0)" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_15-8" x1="579.44" y1="330.36" x2="568.35" y2="301.64" gradientTransform="matrix(-1, 0, 0, 1, 1271.65, 0)" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_15-9" x1="556.39" y1="324.46" x2="547.43" y2="297.73" gradientTransform="matrix(-1, 0, 0, 1, 1271.65, 0)" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_15-10" x1="567.28" y1="320.81" x2="558.32" y2="294.08" gradientTransform="matrix(-1, 0, 0, 1, 1271.65, 0)" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_15-11" x1="578.71" y1="344.7" x2="563.67" y2="376.16" gradientTransform="matrix(-1, 0, 0, 1, 1271.65, 0)" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_15-12" x1="569.99" y1="340.53" x2="554.95" y2="372" gradientTransform="matrix(-1, 0, 0, 1, 1271.65, 0)" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_23-23" x1="891.42" y1="486.08" x2="887.78" y2="508.34" gradientTransform="matrix(-0.96, -0.27, -0.27, 0.96, 1651.02, 91.35)" xlink:href="#New_Gradient_Swatch_23"/>
                <clipPath id="clip-path-4">
                    <path class="cls-1" d="M656.91,347.33l2.76,1.13,2.51,1,0,0h.07L657,347.37H657Z"/>
                </clipPath>
                <linearGradient id="New_Gradient_Swatch_23-24" x1="882.57" y1="509.96" x2="888.28" y2="509.96" gradientTransform="matrix(-0.96, -0.27, -0.27, 0.96, 1651.02, 91.35)" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_23-25" x1="890.4" y1="495.64" x2="884.09" y2="509.02" gradientTransform="matrix(-0.96, -0.27, -0.27, 0.96, 1651.02, 91.35)" xlink:href="#New_Gradient_Swatch_23"/>
                <clipPath id="clip-path-5">
                    <path class="cls-6" d="M665.28,337l4.75,3.22a5.08,5.08,0,0,0,1.13.57,5.39,5.39,0,0,0,.64.19,6,6,0,0,0,.69.11,7.1,7.1,0,0,0,3-.36,9.73,9.73,0,0,0,2.89-1.58,11.61,11.61,0,0,0,2.42-2.59,11.09,11.09,0,0,0,1.55-3.33,9.52,9.52,0,0,0,.32-1.86,7.87,7.87,0,0,0-.07-1.71,6.65,6.65,0,0,0-.43-1.52,5.6,5.6,0,0,0-.74-1.27L677.55,322a5.78,5.78,0,0,1,.78,1.36,7,7,0,0,1,.44,1.65,8.63,8.63,0,0,1,.06,1.88,10.76,10.76,0,0,1-.36,2.06,13,13,0,0,1-1.7,3.73,13.42,13.42,0,0,1-2.63,2.94,10.89,10.89,0,0,1-3.11,1.83,7.43,7.43,0,0,1-3.17.49,6.07,6.07,0,0,1-.73-.1,5.6,5.6,0,0,1-.68-.19,5.32,5.32,0,0,1-.62-.26A5.16,5.16,0,0,1,665.28,337Z"/>
                </clipPath>
                <linearGradient id="New_Gradient_Swatch_23-27" x1="870.4" y1="488.66" x2="878.13" y2="503.13" gradientTransform="matrix(-0.96, -0.27, -0.27, 0.96, 1651.02, 91.35)" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_23-28" x1="599.2" y1="379.59" x2="609.49" y2="379.59" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_23-29" x1="596.34" y1="370.96" x2="596.54" y2="347.6" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_23-30" x1="594.14" y1="383.28" x2="606.65" y2="340.63" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_23-31" x1="589.28" y1="397.01" x2="604.13" y2="397.01" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_23-32" x1="592.28" y1="377.88" x2="550.73" y2="419.43" xlink:href="#New_Gradient_Swatch_23"/>
                <clipPath id="clip-path-6">
                    <path class="cls-7" d="M674.13,350.57l4.34,2.17a2,2,0,0,0,.36,0,3.6,3.6,0,0,0,.87-.16A5.27,5.27,0,0,0,681,352a8.23,8.23,0,0,0,1.56-1.31l2.07-2.2,3.77-4,3.84-4.09,2-2.15-2.8-4.25-2.23,2.47-4.24,4.68-4.15,4.58-2.27,2.49a9.34,9.34,0,0,1-1.7,1.49,5.83,5.83,0,0,1-1.38.69,3.69,3.69,0,0,1-.94.19A2,2,0,0,1,674.13,350.57Z"/>
                </clipPath>
                <linearGradient id="New_Gradient_Swatch_23-34" x1="844.14" y1="484.07" x2="872.05" y2="513.77" gradientTransform="matrix(-0.96, -0.27, -0.27, 0.96, 1651.02, 91.35)" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_23-35" x1="566.82" y1="309.94" x2="582.65" y2="345.03" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_15-13" x1="889.33" y1="480.74" x2="900.52" y2="557.24" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_15-14" x1="878.35" y1="482.62" x2="889.45" y2="558.5" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_15-15" x1="862.64" y1="484.91" x2="873.73" y2="560.8" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_15-16" x1="587.46" y1="321.06" x2="598.55" y2="396.94" gradientTransform="matrix(-1, 0, 0, 1, 1271.65, 0)" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_23-36" x1="588.14" y1="384.02" x2="605.69" y2="379.78" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_15-17" x1="592.46" y1="352.45" x2="575.49" y2="308.49" gradientTransform="matrix(-1, 0, 0, 1, 1271.65, 0)" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_15-18" x1="607.61" y1="346.6" x2="590.64" y2="302.64" gradientTransform="matrix(-1, 0, 0, 1, 1271.65, 0)" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_15-19" x1="605.39" y1="347.45" x2="588.42" y2="303.51" gradientTransform="matrix(-1, 0, 0, 1, 1271.65, 0)" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_15-20" x1="618.66" y1="342.33" x2="601.69" y2="298.38" gradientTransform="matrix(-1, 0, 0, 1, 1271.65, 0)" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_15-21" x1="583.39" y1="333.31" x2="569.68" y2="292.4" gradientTransform="matrix(-1, 0, 0, 1, 1271.65, 0)" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_15-22" x1="600.05" y1="327.73" x2="586.34" y2="286.82" gradientTransform="matrix(-1, 0, 0, 1, 1271.65, 0)" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_15-23" x1="617.53" y1="364.28" x2="594.52" y2="412.42" gradientTransform="matrix(-1, 0, 0, 1, 1271.65, 0)" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_15-24" x1="604.19" y1="357.9" x2="581.18" y2="406.04" gradientTransform="matrix(-1, 0, 0, 1, 1271.65, 0)" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_23-37" x1="937.69" y1="505.52" x2="932.72" y2="535.98" gradientTransform="matrix(-0.96, -0.27, -0.27, 0.96, 1651.02, 91.35)" xlink:href="#New_Gradient_Swatch_23"/>
                <clipPath id="clip-path-7">
                    <path class="cls-1" d="M605.4,363.94l3.77,1.54,3.43,1.41.06,0h.1l-7.2-3h-.1Z"/>
                </clipPath>
                <linearGradient id="New_Gradient_Swatch_23-38" x1="925.58" y1="538.2" x2="933.4" y2="538.2" gradientTransform="matrix(-0.96, -0.27, -0.27, 0.96, 1651.02, 91.35)" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_23-39" x1="936.3" y1="518.61" x2="927.67" y2="536.92" gradientTransform="matrix(-0.96, -0.27, -0.27, 0.96, 1651.02, 91.35)" xlink:href="#New_Gradient_Swatch_23"/>
                <clipPath id="clip-path-8">
                    <path class="cls-8" d="M616.85,349.86l6.5,4.41a6.94,6.94,0,0,0,1.55.79,7.37,7.37,0,0,0,.88.26,8.22,8.22,0,0,0,.94.16,9.72,9.72,0,0,0,4.07-.49,13.31,13.31,0,0,0,4-2.16,15.88,15.88,0,0,0,3.31-3.55,15.17,15.17,0,0,0,2.12-4.55,13,13,0,0,0,.43-2.54,10.77,10.77,0,0,0-.1-2.34,9.1,9.1,0,0,0-.58-2.07,7.66,7.66,0,0,0-1-1.74l-5.27-6.77a7.91,7.91,0,0,1,1.07,1.87,9.56,9.56,0,0,1,.61,2.26,11.8,11.8,0,0,1,.08,2.58,14.73,14.73,0,0,1-.49,2.81,17.77,17.77,0,0,1-2.32,5.1,18.36,18.36,0,0,1-3.6,4,14.9,14.9,0,0,1-4.25,2.5,10.16,10.16,0,0,1-4.34.67,8.31,8.31,0,0,1-1-.14,7.67,7.67,0,0,1-.93-.25,7.28,7.28,0,0,1-.85-.36A7.06,7.06,0,0,1,616.85,349.86Z"/>
                </clipPath>
                <linearGradient id="New_Gradient_Swatch_23-41" x1="908.93" y1="509.05" x2="919.5" y2="528.85" gradientTransform="matrix(-0.96, -0.27, -0.27, 0.96, 1651.02, 91.35)" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_23-42" x1="645" y1="408.07" x2="659.08" y2="408.07" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_23-43" x1="641.09" y1="396.26" x2="641.36" y2="364.3" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_23-44" x1="638.07" y1="413.12" x2="655.19" y2="354.77" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_23-45" x1="631.42" y1="431.9" x2="651.74" y2="431.9" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_23-46" x1="635.54" y1="405.74" x2="578.69" y2="462.58" xlink:href="#New_Gradient_Swatch_23"/>
                <clipPath id="clip-path-9">
                    <path class="cls-9" d="M629,368.37l5.93,3a2.68,2.68,0,0,0,.49,0,4.92,4.92,0,0,0,1.19-.22,7.2,7.2,0,0,0,1.73-.82,11.26,11.26,0,0,0,2.14-1.79l2.83-3,5.16-5.5,5.25-5.6,2.76-2.94-3.83-5.81L649.55,349l-5.8,6.41-5.68,6.26-3.1,3.41a12.78,12.78,0,0,1-2.33,2,8,8,0,0,1-1.88.94,5.05,5.05,0,0,1-1.28.26A2.75,2.75,0,0,1,629,368.37Z"/>
                </clipPath>
                <linearGradient id="New_Gradient_Swatch_23-48" x1="873.01" y1="502.78" x2="911.19" y2="543.41" gradientTransform="matrix(-0.96, -0.27, -0.27, 0.96, 1651.02, 91.35)" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_23-49" x1="600.69" y1="312.79" x2="622.35" y2="360.79" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_15-25" x1="934.83" y1="498.22" x2="950.14" y2="602.88" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_15-26" x1="919.82" y1="500.78" x2="935" y2="604.6" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_15-27" x1="898.31" y1="503.93" x2="913.49" y2="607.75" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_15-28" x1="628.93" y1="327.99" x2="644.11" y2="431.81" gradientTransform="matrix(-1, 0, 0, 1, 1271.65, 0)" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_23-50" x1="629.87" y1="414.14" x2="653.88" y2="408.33" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_15-29" x1="635.78" y1="370.94" x2="612.56" y2="310.8" gradientTransform="matrix(-1, 0, 0, 1, 1271.65, 0)" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_15-30" x1="656.51" y1="362.93" x2="633.29" y2="302.8" gradientTransform="matrix(-1, 0, 0, 1, 1271.65, 0)" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_15-31" x1="653.47" y1="364.11" x2="630.25" y2="303.98" gradientTransform="matrix(-1, 0, 0, 1, 1271.65, 0)" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_15-32" x1="671.62" y1="357.1" x2="648.4" y2="296.97" gradientTransform="matrix(-1, 0, 0, 1, 1271.65, 0)" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_15-33" x1="623.37" y1="344.75" x2="604.62" y2="288.79" gradientTransform="matrix(-1, 0, 0, 1, 1271.65, 0)" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_15-34" x1="646.16" y1="337.12" x2="627.4" y2="281.15" gradientTransform="matrix(-1, 0, 0, 1, 1271.65, 0)" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_15-35" x1="670.08" y1="387.12" x2="638.6" y2="452.99" gradientTransform="matrix(-1, 0, 0, 1, 1271.65, 0)" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_15-36" x1="651.83" y1="378.4" x2="620.35" y2="444.26" gradientTransform="matrix(-1, 0, 0, 1, 1271.65, 0)" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_23-51" x1="1000.67" y1="510.1" x2="993.15" y2="556.08" gradientTransform="matrix(-0.96, -0.27, -0.27, 0.96, 1651.02, 91.35)" xlink:href="#New_Gradient_Swatch_23"/>
                <clipPath id="clip-path-10">
                    <path class="cls-1" d="M540.26,371l5.69,2.33,5.18,2.13.09,0,.07,0h.08l-10.87-4.46h0l0,0-.07,0Z"/>
                </clipPath>
                <linearGradient id="New_Gradient_Swatch_23-52" x1="982.38" y1="559.44" x2="994.18" y2="559.44" gradientTransform="matrix(-0.96, -0.27, -0.27, 0.96, 1651.02, 91.35)" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_23-53" x1="998.56" y1="529.86" x2="985.53" y2="557.5" gradientTransform="matrix(-0.96, -0.27, -0.27, 0.96, 1651.02, 91.35)" xlink:href="#New_Gradient_Swatch_23"/>
                <clipPath id="clip-path-11">
                    <path class="cls-3" d="M557.55,349.74l9.81,6.66a10.48,10.48,0,0,0,2.33,1.19A11.13,11.13,0,0,0,571,358a12.42,12.42,0,0,0,1.42.24,14.67,14.67,0,0,0,6.14-.74,20.09,20.09,0,0,0,6-3.26,24,24,0,0,0,5-5.36,22.9,22.9,0,0,0,3.19-6.87,19.67,19.67,0,0,0,.65-3.83,16.26,16.26,0,0,0-.14-3.54,13.74,13.74,0,0,0-.88-3.13,11.57,11.57,0,0,0-1.53-2.63l-8-10.22a11.94,11.94,0,0,1,1.61,2.82,14.44,14.44,0,0,1,.92,3.41,17.82,17.82,0,0,1,.12,3.89,22.23,22.23,0,0,1-.74,4.25,26.83,26.83,0,0,1-3.51,7.7,27.72,27.72,0,0,1-5.43,6.08,22.5,22.5,0,0,1-6.41,3.78,15.34,15.34,0,0,1-6.55,1,12.54,12.54,0,0,1-1.51-.21A11.57,11.57,0,0,1,560,351a11,11,0,0,1-1.28-.54A10.66,10.66,0,0,1,557.55,349.74Z"/>
                </clipPath>
                <linearGradient id="New_Gradient_Swatch_23-55" x1="957.25" y1="515.44" x2="973.2" y2="545.33" gradientTransform="matrix(-0.96, -0.27, -0.27, 0.96, 1651.02, 91.35)" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_23-56" x1="699.3" y1="437.62" x2="720.56" y2="437.62" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_23-57" x1="693.4" y1="419.79" x2="693.81" y2="371.54" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_23-58" x1="688.84" y1="445.25" x2="714.69" y2="357.16" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_23-59" x1="678.8" y1="473.6" x2="709.48" y2="473.6" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_23-60" x1="685.01" y1="434.1" x2="599.19" y2="519.93" xlink:href="#New_Gradient_Swatch_23"/>
                <clipPath id="clip-path-12">
                    <path class="cls-4" d="M575.83,377.68l9,4.49a4.05,4.05,0,0,0,.74,0,7.43,7.43,0,0,0,1.79-.33,10.88,10.88,0,0,0,2.62-1.23,17,17,0,0,0,3.23-2.7l4.28-4.54,7.79-8.3,7.93-8.45,4.16-4.43-5.79-8.78-4.61,5.1-8.76,9.67-8.57,9.46-4.68,5.15a19.29,19.29,0,0,1-3.51,3.07,12,12,0,0,1-2.84,1.42,7.63,7.63,0,0,1-1.93.4A4.15,4.15,0,0,1,575.83,377.68Z"/>
                </clipPath>
                <linearGradient id="New_Gradient_Swatch_23-62" x1="903.01" y1="505.96" x2="960.65" y2="567.31" gradientTransform="matrix(-0.96, -0.27, -0.27, 0.96, 1651.02, 91.35)" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_23-63" x1="632.41" y1="293.77" x2="665.1" y2="366.24" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_15-37" x1="996.35" y1="499.07" x2="1019.46" y2="657.1" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_15-38" x1="973.68" y1="502.95" x2="996.6" y2="659.69" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_15-39" x1="941.21" y1="507.7" x2="964.13" y2="664.44" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_15-40" x1="675.04" y1="316.72" x2="697.96" y2="473.46" gradientTransform="matrix(-1, 0, 0, 1, 1271.65, 0)" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_23-64" x1="676.45" y1="446.78" x2="712.7" y2="438.01" xlink:href="#New_Gradient_Swatch_23"/>
                <linearGradient id="New_Gradient_Swatch_15-41" x1="685.38" y1="381.56" x2="650.32" y2="290.77" gradientTransform="matrix(-1, 0, 0, 1, 1271.65, 0)" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_15-42" x1="716.67" y1="369.47" x2="681.62" y2="278.69" gradientTransform="matrix(-1, 0, 0, 1, 1271.65, 0)" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_15-43" x1="712.08" y1="371.25" x2="677.03" y2="280.47" gradientTransform="matrix(-1, 0, 0, 1, 1271.65, 0)" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_15-44" x1="739.49" y1="360.66" x2="704.43" y2="269.88" gradientTransform="matrix(-1, 0, 0, 1, 1271.65, 0)" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_15-45" x1="666.65" y1="342.03" x2="638.33" y2="257.53" gradientTransform="matrix(-1, 0, 0, 1, 1271.65, 0)" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_15-46" x1="701.05" y1="330.5" x2="672.73" y2="246" gradientTransform="matrix(-1, 0, 0, 1, 1271.65, 0)" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_15-47" x1="737.17" y1="406" x2="689.64" y2="505.44" gradientTransform="matrix(-1, 0, 0, 1, 1271.65, 0)" xlink:href="#New_Gradient_Swatch_15"/>
                <linearGradient id="New_Gradient_Swatch_15-48" x1="709.6" y1="392.83" x2="662.08" y2="492.26" gradientTransform="matrix(-1, 0, 0, 1, 1271.65, 0)" xlink:href="#New_Gradient_Swatch_15"/>
            </defs>
            <title>pic</title>
            <g id="图层_2" data-name="图层 2">
                <g id="图层_1-2" data-name="图层 1">
                    <ellipse class="cls-10" cx="431.76" cy="591.5" rx="357.52" ry="135.8"/>
                    <g class="cls-11">
                        <ellipse class="cls-12" cx="431.76" cy="597.27" rx="386.33" ry="146.74"/>
                    </g>
                    <ellipse class="cls-13" cx="432.5" cy="613.54" rx="403.89" ry="174.09"/>
                    <ellipse class="cls-14" cx="430.5" cy="527.65" rx="288.82" ry="110.39"/>
                    <g class="cls-15">
                        <circle class="cls-16" cx="479.18" cy="89.35" r="9.1"/>
                        <circle class="cls-17" cx="478.95" cy="89.12" r="14.33"/>
                        <line class="cls-17" x1="479.36" y1="108.19" x2="479.36" y2="110.19"/>
                        <line class="cls-18" x1="479.36" y1="116.11" x2="479.36" y2="419.38"/>
                        <line class="cls-17" x1="479.36" y1="422.34" x2="479.36" y2="424.34"/>
                    </g>
                    <g opacity="0.3">
                    <path class="cls-19" d="M795.27,434.72,626.81,388.63c-6.23-1.7-11.28-9.86-11.28-18.22V217.61c0-8.36,5-13.75,11.28-12l168.46,46.09c6.23,1.7,11.28,9.86,11.28,18.22V422.67C806.54,431,801.49,436.42,795.27,434.72Z"/>
                    <path class="cls-20" d="M788.9,442.72,610,393.78c-6.61-1.81-12-10.47-12-19.34V212.15c0-8.87,5.36-14.6,12-12.79L788.9,248.3c6.61,1.81,12,10.47,12,19.34V429.93C800.88,438.81,795.52,444.53,788.9,442.72Z"/>
                    <path class="cls-21" d="M782.54,450.73,593.2,398.93c-7-1.91-12.67-11.08-12.67-20.47V206.7c0-9.39,5.67-15.45,12.67-13.54L782.54,245c7,1.91,12.67,11.08,12.67,20.47V437.19C795.22,446.58,789.54,452.65,782.54,450.73Z"/>
                    <path class="cls-22" d="M776.18,458.74,576.4,404.08c-7.39-2-13.37-11.69-13.37-21.6V201.25c0-9.91,6-16.31,13.37-14.29l199.78,54.66c7.39,2,13.37,11.69,13.37,21.6V444.45C789.56,454.36,783.57,460.76,776.18,458.74Z"/>
                    <path class="cls-23" d="M769.82,466.74,559.59,409.23c-7.77-2.13-14.07-12.3-14.07-22.73V195.8c0-10.43,6.3-17.16,14.07-15l210.23,57.51c7.77,2.13,14.07,12.3,14.07,22.73v190.7C783.89,462.14,777.59,468.87,769.82,466.74Z"/>
                    <path class="cls-24" d="M763.46,474.75,542.79,414.38c-8.16-2.23-14.77-12.92-14.77-23.86V190.34c0-10.95,6.61-18,14.77-15.78l220.67,60.37c8.16,2.23,14.77,12.92,14.77,23.86V459C778.23,469.92,771.62,477,763.46,474.75Z"/>
                    <path class="cls-25" d="M757.1,482.76,526,419.53c-8.54-2.34-15.47-13.53-15.47-25V184.89c0-11.46,6.93-18.86,15.47-16.53L757.1,231.59c8.54,2.34,15.47,13.53,15.47,25V466.23C772.57,477.7,765.64,485.09,757.1,482.76Z"/>
                    <path class="cls-26" d="M750.74,490.76,509.18,424.68c-8.93-2.44-16.17-14.14-16.17-26.12V179.44c0-12,7.24-19.72,16.17-17.27l241.56,66.08c8.93,2.44,16.17,14.14,16.17,26.12V473.49C766.91,485.47,759.67,493.21,750.74,490.76Z"/>
                    <path class="cls-27" d="M744.38,498.77l-252-68.94c-9.32-2.55-16.87-14.75-16.87-27.25V174c0-12.5,7.55-20.57,16.87-18l252,68.94c9.32,2.55,16.87,14.75,16.87,27.25V480.75C761.24,493.25,753.69,501.32,744.38,498.77Z"/>
                    <path class="cls-28" d="M738,506.78,475.57,435c-9.7-2.65-17.57-15.36-17.57-28.38V168.54c0-13,7.87-21.42,17.57-18.77L738,221.57c9.7,2.65,17.57,15.36,17.57,28.38V488C755.58,501,747.72,509.43,738,506.78Z"/>
                    <path class="cls-29" d="M731.65,514.78,458.77,440.13c-10.09-2.76-18.27-16-18.27-29.51V163.08c0-13.54,8.18-22.27,18.27-19.51l272.88,74.65c10.09,2.76,18.27,16,18.27,29.51V495.27C749.92,508.81,741.74,517.54,731.65,514.78Z"/>
                    <path class="cls-30" d="M725.29,522.79,442,445.28c-10.47-2.87-19-16.58-19-30.64v-257c0-14.05,8.49-23.13,19-20.26l283.33,77.51c10.47,2.87,19,16.58,19,30.64v257C744.26,516.59,735.77,525.66,725.29,522.79Z"/>
                    <path class="cls-31" d="M718.93,530.8,425.16,450.43c-10.86-3-19.66-17.19-19.66-31.77V152.18c0-14.57,8.8-24,19.66-21l293.77,80.37c10.86,3,19.66,17.19,19.66,31.77V509.79C738.6,524.36,729.79,533.77,718.93,530.8Z"/>
                    <path class="cls-32" d="M712.57,538.8,408.36,455.58c-11.25-3.08-20.36-17.8-20.36-32.9v-276c0-15.09,9.12-24.83,20.36-21.75L712.57,208.2c11.25,3.08,20.36,17.8,20.36,32.9v276C732.93,532.14,723.82,541.88,712.57,538.8Z"/>
                    <path class="cls-33" d="M706.21,546.81,391.55,460.73c-11.63-3.18-21.06-18.42-21.06-34V141.28c0-15.61,9.43-25.68,21.06-22.5l314.65,86.08c11.63,3.18,21.06,18.42,21.06,34V524.31C727.27,539.92,717.84,550,706.21,546.81Z"/>
                    <path class="cls-34" d="M699.85,554.82l-325.1-88.94c-12-3.29-21.76-19-21.76-35.15V135.82c0-16.13,9.74-26.53,21.76-23.25l325.1,88.94c12,3.29,21.76,19,21.76,35.15v294.9C721.61,547.7,711.87,558.1,699.85,554.82Z"/>
                    <path class="cls-35" d="M693.49,562.82,357.95,471c-12.4-3.39-22.46-19.64-22.46-36.28V130.37c0-16.64,10.06-27.39,22.46-24l335.54,91.8c12.4,3.39,22.46,19.64,22.46,36.28V538.83C715.95,555.47,705.89,566.22,693.49,562.82Z"/>
                    <path class="cls-36" d="M687.12,570.83l-346-94.65c-12.79-3.5-23.16-20.25-23.16-37.41V124.92c0-17.16,10.37-28.24,23.16-24.74l346,94.65c12.79,3.5,23.16,20.25,23.16,37.41V546.09C710.28,563.25,699.92,574.33,687.12,570.83Z"/>
                    <path class="cls-37" d="M680.76,578.84,324.34,481.33c-13.18-3.6-23.86-20.86-23.86-38.54V119.47c0-17.68,10.68-29.09,23.86-25.49l356.42,97.51c13.18,3.6,23.86,20.86,23.86,38.54V553.35C704.62,571,693.94,582.44,680.76,578.84Z"/>
                    <path class="cls-38" d="M674.4,586.84,307.53,486.48C294,482.77,283,465,283,446.81V114c0-18.2,11-29.94,24.56-26.23L674.4,188.15C688,191.86,699,209.62,699,227.82V560.61C699,578.81,688,590.55,674.4,586.84Z"/>
                    <path class="cls-39" d="M668,594.85,290.73,491.63c-13.95-3.82-25.26-22.08-25.26-40.8V108.56c0-18.72,11.31-30.8,25.26-27L668,184.8c13.95,3.82,25.26,22.08,25.26,40.8V567.87C693.3,586.59,682,598.67,668,594.85Z"/>
                    <path class="cls-40" d="M661.68,602.86,273.93,496.78c-14.34-3.92-26-22.69-26-41.93V103.11c0-19.24,11.62-31.65,26-27.73L661.68,181.46c14.34,3.92,26,22.69,26,41.93V575.13C687.64,594.36,676,606.78,661.68,602.86Z"/>
                    <path class="cls-41" d="M576.28,623.44,188.53,517.36c-14.34-3.92-26-22.69-26-41.93V123.69c0-19.24,11.62-31.65,26-27.73L576.28,202c14.34,3.92,26,22.69,26,41.93V595.71C602.24,614.94,590.62,627.36,576.28,623.44Z"/>
                    </g>
                    <g class="cls-42">
                        <path class="cls-43 cls-41-line" d="M183.32,106h0a9,9,0,0,1,2.36.34L573.43,212.47c8.51,2.33,18,15.84,18,31.5V595.71c0,10.06-4.27,17.64-9.93,17.64a9,9,0,0,1-2.36-.34L191.38,506.93c-8.51-2.33-18-15.84-18-31.5V123.69c0-10.06,4.27-17.64,9.93-17.64m0-10.81c-11.84,0-20.74,11.61-20.74,28.45V475.43c0,19.23,11.62,38,26,41.93L576.28,623.44a19.72,19.72,0,0,0,5.21.72c11.84,0,20.74-11.61,20.74-28.45V244c0-19.23-11.62-38-26-41.93L188.53,96a19.72,19.72,0,0,0-5.21-.72Z"/>
                    </g>
                    <path class="cls-44" d="M449.25,505.28,87.05,406.19c-6-1.63-10.82-9.46-10.82-17.48V216.42c0-8,4.84-13.19,10.82-11.56l362.19,99.09c6,1.64,10.82,9.46,10.82,17.48V493.72C460.07,501.74,455.22,506.91,449.25,505.28Z"/>
                    <path class="cls-45" d="M483.3,476.09,121.11,377c-6-1.63-10.82-9.46-10.82-17.48V187.23c0-8,4.84-13.19,10.82-11.56L483.3,274.76c6,1.63,10.82,9.46,10.82,17.48V464.53C494.12,472.55,489.27,477.73,483.3,476.09Z"/>
                    <g class="cls-46-group">
                        <polygon class="cls-46" points="145.25 466.61 127.75 461.63 127.75 426.51 145.25 431.49 145.25 466.61"/>
                        <polygon class="cls-46" points="170.05 473.66 152.55 468.68 152.55 433.56 170.05 438.54 170.05 473.66"/>
                        <polygon class="cls-46" points="194.13 480.51 176.62 475.53 176.62 440.41 194.13 445.39 194.13 480.51"/>
                        <polygon class="cls-46" points="218.93 487.57 201.42 482.59 201.42 447.47 218.93 452.45 218.93 487.57"/>
                        <polygon class="cls-46" points="243.36 494.52 225.86 489.54 225.86 454.42 243.36 459.4 243.36 494.52"/>
                        <polygon class="cls-46" points="268.17 501.58 250.66 496.6 250.66 461.48 268.17 466.46 268.17 501.58"/>
                        <polygon class="cls-46" points="293.55 508.8 276.05 503.82 276.05 468.7 293.55 473.68 293.55 508.8"/>
                        <polygon class="cls-46" points="318.35 515.86 300.85 510.88 300.85 475.76 318.35 480.74 318.35 515.86"/>
                        <polygon class="cls-46" points="342.43 522.71 324.92 517.73 324.92 482.61 342.43 487.59 342.43 522.71"/>
                        <polygon class="cls-46" points="367.23 529.77 349.72 524.79 349.72 489.67 367.23 494.65 367.23 529.77"/>
                        <polygon class="cls-46" points="391.66 536.72 374.16 531.74 374.16 496.62 391.66 501.6 391.66 536.72"/>
                        <polygon class="cls-46" points="416.46 543.78 398.96 538.8 398.96 503.68 416.46 508.66 416.46 543.78"/>
                    </g>
                    <g class="cls-47-group">
                        <polygon class="cls-47" points="133.3 447.33 104.65 439.49 104.65 384.23 133.3 392.07 133.3 447.33"/>
                        <polygon class="cls-48" points="173.89 458.43 145.24 450.59 145.24 395.33 173.89 403.17 173.89 458.43"/>
                        <polygon class="cls-49" points="213.28 469.21 184.64 461.37 184.64 406.11 213.28 413.95 213.28 469.21"/>
                        <polygon class="cls-50" points="253.87 480.31 225.22 472.48 225.22 417.21 253.87 425.05 253.87 480.31"/>
                        <polygon class="cls-51" points="293.87 491.25 265.22 483.42 265.22 428.15 293.87 435.99 293.87 491.25"/>
                        <polygon class="cls-52" points="334.45 502.36 305.81 494.52 305.81 439.26 334.45 447.1 334.45 502.36"/>
                    </g>
                    <g class="cls-logo">
                        <path class="cls-43" d="M491.54,210.6c-2.24-.61-3.67,1.59-3.67,5.94s1.43,7.47,3.67,8.09,3.67-1.76,3.67-6.08S493.78,211.21,491.54,210.6Z"/>
                        <path class="cls-43" d="M461.23,202.3c-2.24-.61-3.67,1.59-3.67,5.94s1.43,7.47,3.67,8.09,3.67-1.76,3.67-6.08S463.47,202.92,461.23,202.3Z"/>
                        <path class="cls-43" d="M429.6,176.46v28.31c0,8.45,5.11,16.7,11.41,18.42l58.61,16c6.3,1.72,11.41-3.73,11.41-12.18V198.73Zm23.78,40.84-9.13-2.5V194.57l3,.83v16.84l6.11,1.67Zm7.85,2.53c-4-1.09-6.75-5.87-6.75-12.43s2.75-9.67,6.75-8.57,6.75,5.7,6.75,12.26S465.23,220.92,461.23,219.83Zm21.08,3.33a4.87,4.87,0,0,1-4.89,1.1c-4.12-1.13-7.23-5.64-7.23-12.4s3.22-9.7,7.23-8.6a8.21,8.21,0,0,1,4.67,3.87l-1.61,2.13a5.16,5.16,0,0,0-3-2.5c-2.51-.69-4.26,1.46-4.26,5.81s1.51,7.47,4.46,8.28a2.1,2.1,0,0,0,1.9-.25v-4l-2.67-.73v-3.31l5.36,1.47Zm9.24,5c-4-1.09-6.75-5.87-6.75-12.43s2.75-9.67,6.75-8.57,6.75,5.7,6.75,12.26S495.54,229.22,491.54,228.12Z"/>
                    </g>
                    <g id="_2.0" data-name="2.0" class="cls-53">
                        <g id="工具-模板设置">
                            <g id="Group-3-Copy-2">
                                <g id="图片">
                                    <path id="Shape" class="cls-54" d="M273.47,233.47,136.76,194.91c-6.41-1.81-11.7,1.75-11.79,7.93L123.54,303.7c-.09,6.18,5.06,12.68,11.47,14.49l136.71,38.56c6.41,1.81,11.7-1.75,11.79-7.93L284.94,248C285,241.78,279.88,235.28,273.47,233.47ZM136.66,202.19l136.71,38.56a5.61,5.61,0,0,1,4,5.07L276,342l-46.73-72.23c-18.61-7.27-15.43,13.81-15.43,13.81l31.71,58.46-11.9-3.36-45.59-80.54c-12.5-21.69-24.53-6.92-24.53-6.92l-30,28.12-2.15,2L132.53,205c0-2.16,1.88-3.41,4.13-2.78Z"/>
                                </g>
                            </g>
                        </g>
                    </g>
                    <g id="_2.0-2" data-name="2.0">
                        <g id="工具-模板设置-2" data-name="工具-模板设置">
                            <g id="Group-3-Copy">
                                <g id="文字">
                                    <path id="Shape-2" data-name="Shape" class="cls-55" d="M393.44,470.42V464.1a.79.79,0,0,0-.59-.73l-46.71-12.52a.42.42,0,0,0-.59.42v6.32a.79.79,0,0,0,.59.73l19.61,5.26v46.84a.39.39,0,0,0,.29.37l7,1.87a.21.21,0,0,0,.29-.21V465.56l19.61,5.26A.4.4,0,0,0,393.44,470.42Zm4.52,20-4.1-1.1-11.12,25.4,4.06,1.09,3.18-7.76,12.08,3.24,3.39,9.52,4.35,1.17Zm-6.86,14.9,3.18-7.47a30.21,30.21,0,0,0,1.55-5c.46,1.64,1.13,3.79,2,6.46l3,8.68-9.78-2.62Z"/>
                                </g>
                            </g>
                        </g>
                    </g>
                    <polygon class="cls-56" points="644.63 498.97 576.71 452.46 508.79 498.97 576.71 545.48 644.63 498.97"/>
                    <polygon class="cls-57" points="576.71 555.85 516.74 516.32 508.79 524.58 576.71 571.08 644.63 524.58 636.56 516.12 576.71 555.85"/>
                    <polygon class="cls-58" points="576.71 581.48 516.74 541.94 508.79 550.22 576.71 596.73 644.63 550.22 636.56 541.76 576.71 581.48"/>
                    <g class="cls-59">
                        <polygon class="cls-60" points="695.28 322.22 698.55 324.55 699.25 316.26 697.09 313.39 695.28 322.22"/>
                        <g class="cls-61">
                            <path class="cls-62" d="M694.77,333.63l3.44,1.41h.07l-3.44-1.41h-.08Z"/>
                        </g>
                        <polygon class="cls-63" points="694.85 333.65 698.29 335.06 699.78 329.55 696.49 327.61 694.85 333.65"/>
                        <polygon class="cls-64" points="696.49 327.61 699.78 329.55 698.55 324.55 695.28 322.22 696.49 327.61"/>
                        <path class="cls-2" d="M700.24,326.9l3.1,2.11a3.27,3.27,0,0,0,.35.21l.39.17.42.12.45.07a4.64,4.64,0,0,0,1.94-.24,6.36,6.36,0,0,0,1.89-1,7.59,7.59,0,0,0,1.58-1.69,7.25,7.25,0,0,0,1-2.17,6.22,6.22,0,0,0,.21-1.21,5.14,5.14,0,0,0,0-1.12,4.35,4.35,0,0,0-.28-1,3.66,3.66,0,0,0-.48-.83l-2.52-3.23a3.78,3.78,0,0,1,.51.89,4.57,4.57,0,0,1,.29,1.08,5.64,5.64,0,0,1,0,1.23,7,7,0,0,1-.23,1.34,8.49,8.49,0,0,1-1.11,2.44A8.77,8.77,0,0,1,706,326a7.12,7.12,0,0,1-2,1.2,4.85,4.85,0,0,1-2.07.32,4,4,0,0,1-.48-.07,3.66,3.66,0,0,1-.44-.12,3.48,3.48,0,0,1-.41-.17A3.37,3.37,0,0,1,700.24,326.9Z"/>
                        <g class="cls-65">
                            <path class="cls-66" d="M700.24,326.9l3.1,2.11a3.27,3.27,0,0,0,.35.21l.39.17.42.12.45.07a4.64,4.64,0,0,0,1.94-.24,6.36,6.36,0,0,0,1.89-1,7.59,7.59,0,0,0,1.58-1.69,7.25,7.25,0,0,0,1-2.17,6.22,6.22,0,0,0,.21-1.21,5.14,5.14,0,0,0,0-1.12,4.35,4.35,0,0,0-.28-1,3.66,3.66,0,0,0-.48-.83l-2.52-3.23a3.78,3.78,0,0,1,.51.89,4.57,4.57,0,0,1,.29,1.08,5.64,5.64,0,0,1,0,1.23,7,7,0,0,1-.23,1.34,8.49,8.49,0,0,1-1.11,2.44A8.77,8.77,0,0,1,706,326a7.12,7.12,0,0,1-2,1.2,4.85,4.85,0,0,1-2.07.32,4,4,0,0,1-.48-.07,3.66,3.66,0,0,1-.44-.12,3.48,3.48,0,0,1-.41-.17,3.37,3.37,0,0,1-.37-.22Z"/>
                        </g>
                        <polygon class="cls-67" points="698.2 349.63 701.62 348.71 702.07 348.54 698.67 349.44 698.2 349.63"/>
                        <polygon class="cls-68" points="701.7 360.71 704.92 358.63 701.62 348.71 698.2 349.63 701.7 360.71"/>
                        <polygon class="cls-69" points="703.23 346.88 706.35 346.18 710.18 330.82 707.52 328.69 703.23 346.88"/>
                        <polygon class="cls-70" points="706.95 356.59 709.59 354.93 706.35 346.18 703.23 346.88 706.95 356.59"/>
                        <path class="cls-71" d="M704.92,358.63l4.52,3.69a5.68,5.68,0,0,1,1.13,1.33,5.78,5.78,0,0,1,.67,1.57,4.65,4.65,0,0,1,.14,1.59,3.15,3.15,0,0,1-.44,1.38L709.84,370,707,373.55l1.2-1.94a3.5,3.5,0,0,0,.48-1.53,5.43,5.43,0,0,0-.16-1.79,6.86,6.86,0,0,0-.73-1.79,6.65,6.65,0,0,0-1.22-1.53l-4.85-4.26Z"/>
                        <polygon class="cls-72" points="721.43 363.08 721.75 360.42 709.59 354.93 706.95 356.59 721.43 363.08"/>
                        <path class="cls-73" d="M705.79,336l1.72-7.3,2.67,2.14-1.62,6.5Z"/>
                        <path class="cls-5" d="M706,335.74l2.83,1.42a1.28,1.28,0,0,0,.24,0,2.35,2.35,0,0,0,.57-.1,3.44,3.44,0,0,0,.83-.39,5.38,5.38,0,0,0,1-.85l1.35-1.44,2.47-2.63,2.51-2.67,1.32-1.4-1.83-2.78-1.46,1.61-2.77,3.06-2.71,3-1.48,1.63a6.1,6.1,0,0,1-1.11,1,3.81,3.81,0,0,1-.9.45,2.41,2.41,0,0,1-.61.13A1.31,1.31,0,0,1,706,335.74Z"/>
                        <g class="cls-74">
                            <path class="cls-75" d="M706,335.74l2.83,1.42a1.28,1.28,0,0,0,.24,0,2.35,2.35,0,0,0,.57-.1,3.44,3.44,0,0,0,.83-.39,5.38,5.38,0,0,0,1-.85l1.35-1.44,2.47-2.63,2.51-2.67,1.32-1.4-1.83-2.78-1.46,1.61-2.77,3.06-2.71,3-1.48,1.63a6.1,6.1,0,0,1-1.11,1,3.81,3.81,0,0,1-.9.45,2.41,2.41,0,0,1-.61.13,1.31,1.31,0,0,1-.25,0Z"/>
                        </g>
                        <path class="cls-76" d="M722.57,314.46a5.29,5.29,0,0,0,.33-.76,4.26,4.26,0,0,0,.18-.74,3.49,3.49,0,0,0,0-.7,3,3,0,0,0-.1-.64l1.21,4.36a2.73,2.73,0,0,1,.09.58,3.14,3.14,0,0,1,0,.62,3.74,3.74,0,0,1-.16.65,4.4,4.4,0,0,1-.29.67l-4.69,9.16-1.83-2.78Z"/>
                        <path class="cls-77" d="M694.26,315.74a5.18,5.18,0,0,1,.67-1,4.83,4.83,0,0,1,.86-.79,3.43,3.43,0,0,1,1-.49l.31-.09-1.81,8.83,1.21,5.39-1.65,6a.69.69,0,0,1-.16-.07,1.3,1.3,0,0,1-.33-.26,2.09,2.09,0,0,1-.37-.57,3.87,3.87,0,0,1-.29-1c0-.18-.12-.75-.24-1.5l-.42-2.58-.39-2.44-.19-1.21,1.43-7.21A4.19,4.19,0,0,1,694.26,315.74Z"/>
                        <path class="cls-78" d="M706,326a7.12,7.12,0,0,1-2,1.2,4.85,4.85,0,0,1-2.07.32,3.37,3.37,0,0,1-2.83-1.89,4.65,4.65,0,0,1-.46-1.8,6.61,6.61,0,0,1,.24-2.14,8.47,8.47,0,0,1,.92-2.14,8.92,8.92,0,0,1,1.44-1.81,7.75,7.75,0,0,1,1.82-1.31,5.57,5.57,0,0,1,2-.61,3.78,3.78,0,0,1,1.9.3,3.32,3.32,0,0,1,1.38,1.18,4.3,4.3,0,0,1,.68,1.91,6.42,6.42,0,0,1-.21,2.43,8.49,8.49,0,0,1-1.11,2.44A8.77,8.77,0,0,1,706,326Z"/>
                        <path class="cls-79" d="M717.32,324.9l-1.46,1.61-2.77,3.06-2.71,3-1.48,1.63a6.1,6.1,0,0,1-1.11,1,3.81,3.81,0,0,1-.9.45,2.41,2.41,0,0,1-.61.13,1.31,1.31,0,0,1-.25,0l1.94-7.12,5.79-6.31,6.5-12.55.49.06a2.83,2.83,0,0,1,1.36.49,2.35,2.35,0,0,1,.82,1,3,3,0,0,1,.18,1.45,4.59,4.59,0,0,1-.53,1.67Z"/>
                        <path class="cls-80" d="M703.22,346.88l3.73,9.71,14.48,6.49-.35,1.71a3.12,3.12,0,0,1-.53,1.1,3.23,3.23,0,0,1-.87.8,3.9,3.9,0,0,1-1.13.47,4.9,4.9,0,0,1-1.3.14l-.58,0c-.19,0-.39-.06-.59-.11s-.4-.1-.6-.17-.4-.14-.6-.23l-12.73-6.39-3.48-10.93-.47.18,3.51,11.08,4.85,4.26a6.65,6.65,0,0,1,1.22,1.53,6.86,6.86,0,0,1,.73,1.79,5.43,5.43,0,0,1,.16,1.79,3.5,3.5,0,0,1-.48,1.53l-1.2,1.94-9.83-10.77-2.4-8.13L692.62,346l4.18-18.3,10.72,1Z"/>
                        <path class="cls-81" d="M708.49,370.08a5.44,5.44,0,0,0-.16-1.79,6.86,6.86,0,0,0-.73-1.79,6.65,6.65,0,0,0-1.22-1.53l-4.67-4.26,4.85,4.26a6.65,6.65,0,0,1,1.22,1.53,6.86,6.86,0,0,1,.73,1.79,5.43,5.43,0,0,1,.16,1.79,3.5,3.5,0,0,1-.48,1.53l-1.2,1.94,1-1.94A3.51,3.51,0,0,0,708.49,370.08Z"/>
                        <polygon class="cls-82" points="721.43 363.08 706.78 356.67 703.05 346.98 707.52 328.69 703.23 346.88 706.95 356.59 721.43 363.08"/>
                        <polygon class="cls-83" points="717.39 324.81 719.11 327.6 717.27 324.96 717.39 324.81"/>
                        <path class="cls-84" d="M715.72,360.52,707,356.59l2.64-1.65,4.23,1.91A6.72,6.72,0,0,1,715.72,360.52Z"/>
                        <path class="cls-85" d="M713.82,356.84a6.72,6.72,0,0,1,1.9,3.68l-.7-.31A5.55,5.55,0,0,0,713.82,356.84Z"/>
                        <path class="cls-86" d="M722.57,314.46l-5.25,10.44-1.46,1.61-2.77,3.06-2.71,3-1.48,1.63a6.1,6.1,0,0,1-1.11,1,3.81,3.81,0,0,1-.9.45,2.41,2.41,0,0,1-.61.13,1.31,1.31,0,0,1-.25,0l1.94-7.12,5.79-6.31,6.5-12.55.49.06a2.83,2.83,0,0,1,1.36.49,2.35,2.35,0,0,1,.82,1,3,3,0,0,1,.18,1.45A4.59,4.59,0,0,1,722.57,314.46Z"/>
                        <path class="cls-87" d="M703.07,316.39a5.57,5.57,0,0,1,2-.61,3.78,3.78,0,0,1,1.9.3,3.32,3.32,0,0,1,1.38,1.18,4.3,4.3,0,0,1,.68,1.91,6.42,6.42,0,0,1-.21,2.43,8.49,8.49,0,0,1-1.11,2.44A8.77,8.77,0,0,1,706,326a7.12,7.12,0,0,1-2,1.2,4.85,4.85,0,0,1-2.07.32,3.37,3.37,0,0,1-2.83-1.89,4.65,4.65,0,0,1-.46-1.8,6.61,6.61,0,0,1,.24-2.14,8.47,8.47,0,0,1,.92-2.14,8.92,8.92,0,0,1,1.44-1.81A7.75,7.75,0,0,1,703.07,316.39Z"/>
                        <path class="cls-88" d="M696.8,327.73l10.72,1-2.66,11.26a39.74,39.74,0,0,1-6.24-4.83,18.38,18.38,0,0,1-2.73-3.41Z"/>
                        <path class="cls-89" d="M693.87,316.82a4.19,4.19,0,0,1,.4-1.08,5.18,5.18,0,0,1,.67-1,4.83,4.83,0,0,1,.86-.79,3.43,3.43,0,0,1,1-.49l.31-.09-1.81,8.83,1.21,5.39-1,3.52a34.76,34.76,0,0,1-3.09-7V324Z"/>
                        <path class="cls-90" d="M710.89,325.42l2.86-3.11,6.5-12.55.49.06a2.83,2.83,0,0,1,1.36.49,2.35,2.35,0,0,1,.82,1,3,3,0,0,1,.18,1.45,4.59,4.59,0,0,1-.53,1.67l-5.25,10.44-1,1.07A17.89,17.89,0,0,1,710.89,325.42Z"/>
                        <path class="cls-91" d="M703.07,316.39a5.57,5.57,0,0,1,2-.61,3.78,3.78,0,0,1,1.9.3,3.32,3.32,0,0,1,1.38,1.18,4.3,4.3,0,0,1,.68,1.91,6.42,6.42,0,0,1-.21,2.43,8.49,8.49,0,0,1-1.11,2.44l-.17.23c-3.4-1.41-5.91-3.21-7.34-5.43a8.87,8.87,0,0,1,1-1.15A7.75,7.75,0,0,1,703.07,316.39Z"/>
                        <path class="cls-55" d="M722.46,314.49a4.59,4.59,0,0,0,.53-1.67,3.13,3.13,0,0,0-.07-1.47,3,3,0,0,1,.18,1.45,4.59,4.59,0,0,1-.53,1.67l-5.22,10.47c-.1.11-.69.71-1.48,1.58l-2.77,3.06-2.71,3-1.48,1.63,8.3-9.35Z"/>
                        <path class="cls-55" d="M700.17,326.84a3.45,3.45,0,0,0,1.72.59,4.85,4.85,0,0,0,2.07-.32,7.13,7.13,0,0,0,2-1.2,8.79,8.79,0,0,0,1.72-1.92,8.49,8.49,0,0,0,1.11-2.44,6.42,6.42,0,0,0,.21-2.43,4.3,4.3,0,0,0-.67-1.91,3.52,3.52,0,0,0-.28-.37,3.53,3.53,0,0,1,.33.41,4.3,4.3,0,0,1,.68,1.91,6.42,6.42,0,0,1-.21,2.43,8.49,8.49,0,0,1-1.11,2.44A8.77,8.77,0,0,1,706,326a7.12,7.12,0,0,1-2,1.2,4.85,4.85,0,0,1-2.07.32,3.46,3.46,0,0,1-1.72-.59,3.18,3.18,0,0,1-.38-.31A3.27,3.27,0,0,0,700.17,326.84Z"/>
                        <polygon class="cls-92" points="695.09 322.19 697.09 313.39 695.28 322.22 696.49 327.61 694.85 333.65 696.4 327.6 695.09 322.19"/>
                        <path class="cls-93" d="M701.1,358.79l.61,1.92,4.85,4.26a6.65,6.65,0,0,1,1.22,1.53,6.86,6.86,0,0,1,.73,1.79,5.43,5.43,0,0,1,.16,1.79,3.5,3.5,0,0,1-.48,1.53l-1.2,1.94-9.83-10.77-.89-3Q698.62,359.17,701.1,358.79Z"/>
                        <path class="cls-94" d="M701.62,358.71a57.24,57.24,0,0,1,8.11-.57h.69l11,4.94-.35,1.71a3.12,3.12,0,0,1-.53,1.1,3.23,3.23,0,0,1-.87.8,3.9,3.9,0,0,1-1.13.47,4.9,4.9,0,0,1-1.3.14l-.58,0c-.19,0-.39-.06-.59-.11s-.4-.1-.6-.17-.4-.14-.6-.23l-12.73-6.39Z"/>
                    </g>
                    <g class="cls-95">
                        <polygon class="cls-96" points="657.69 329.87 662.7 333.44 663.76 320.76 660.46 316.37 657.69 329.87"/>
                        <g class="cls-97">
                            <path class="cls-62" d="M656.91,347.33l5.26,2.16,0,0h.07L657,347.37H657l0,0Z"/>
                        </g>
                        <polygon class="cls-98" points="657.03 347.37 662.29 349.53 664.58 341.1 659.55 338.12 657.03 347.37"/>
                        <polygon class="cls-99" points="659.55 338.12 664.58 341.1 662.7 333.44 657.69 329.87 659.55 338.12"/>
                        <path class="cls-6" d="M665.28,337l4.75,3.22a5.08,5.08,0,0,0,1.13.57,5.39,5.39,0,0,0,.64.19,6,6,0,0,0,.69.11,7.1,7.1,0,0,0,3-.36,9.73,9.73,0,0,0,2.89-1.58,11.61,11.61,0,0,0,2.42-2.59,11.09,11.09,0,0,0,1.55-3.33,9.52,9.52,0,0,0,.32-1.86,7.87,7.87,0,0,0-.07-1.71,6.65,6.65,0,0,0-.43-1.52,5.6,5.6,0,0,0-.74-1.27L677.55,322a5.78,5.78,0,0,1,.78,1.36,7,7,0,0,1,.44,1.65,8.63,8.63,0,0,1,.06,1.88,10.76,10.76,0,0,1-.36,2.06,13,13,0,0,1-1.7,3.73,13.42,13.42,0,0,1-2.63,2.94,10.89,10.89,0,0,1-3.11,1.83,7.43,7.43,0,0,1-3.17.49,6.07,6.07,0,0,1-.73-.1,5.6,5.6,0,0,1-.68-.19,5.32,5.32,0,0,1-.62-.26A5.16,5.16,0,0,1,665.28,337Z"/>
                        <g class="cls-100">
                            <path class="cls-101" d="M665.28,337l4.75,3.22a5.08,5.08,0,0,0,1.13.57,5.39,5.39,0,0,0,.64.19,6,6,0,0,0,.69.11,7.1,7.1,0,0,0,3-.36,9.73,9.73,0,0,0,2.89-1.58,11.61,11.61,0,0,0,2.42-2.59,11.09,11.09,0,0,0,1.55-3.33,9.52,9.52,0,0,0,.32-1.86,7.87,7.87,0,0,0-.07-1.71,6.65,6.65,0,0,0-.43-1.52,5.6,5.6,0,0,0-.74-1.27L677.55,322a5.78,5.78,0,0,1,.78,1.36,7,7,0,0,1,.44,1.65,8.63,8.63,0,0,1,.06,1.88,10.76,10.76,0,0,1-.36,2.06,13,13,0,0,1-1.7,3.73,13.42,13.42,0,0,1-2.63,2.94,10.89,10.89,0,0,1-3.11,1.83,7.43,7.43,0,0,1-3.17.49,6.07,6.07,0,0,1-.73-.1,5.6,5.6,0,0,1-.68-.19,5.32,5.32,0,0,1-.62-.26,5.16,5.16,0,0,1-.57-.33Z"/>
                        </g>
                        <polygon class="cls-67" points="662.15 371.81 667.39 370.4 668.07 370.14 662.88 371.53 662.15 371.81"/>
                        <polygon class="cls-102" points="667.52 388.77 672.45 385.6 667.39 370.4 662.15 371.81 667.52 388.77"/>
                        <polygon class="cls-103" points="669.85 367.61 674.64 366.55 680.5 343.04 676.42 339.77 669.85 367.61"/>
                        <polygon class="cls-104" points="675.55 382.47 679.59 379.93 674.64 366.55 669.85 367.61 675.55 382.47"/>
                        <path class="cls-105" d="M672.45,385.6l6.91,5.64a8.7,8.7,0,0,1,1.73,2,8.84,8.84,0,0,1,1,2.4,7.11,7.11,0,0,1,.22,2.43,4.82,4.82,0,0,1-.68,2.11L680,402.94l-4.38,5.48,1.83-3a5.35,5.35,0,0,0,.74-2.34,8.3,8.3,0,0,0-.24-2.74,10.5,10.5,0,0,0-1.12-2.73,10.18,10.18,0,0,0-1.87-2.35l-7.41-6.52Z"/>
                        <polygon class="cls-106" points="697.71 392.4 698.2 388.32 679.59 379.93 675.55 382.47 697.71 392.4"/>
                        <path class="cls-73" d="M673.78,350.95l2.64-11.18L680.5,343,678,353Z"/>
                        <path class="cls-7" d="M674.13,350.57l4.34,2.17a2,2,0,0,0,.36,0,3.6,3.6,0,0,0,.87-.16A5.27,5.27,0,0,0,681,352a8.23,8.23,0,0,0,1.56-1.31l2.07-2.2,3.77-4,3.84-4.09,2-2.15-2.8-4.25-2.23,2.47-4.24,4.68-4.15,4.58-2.27,2.49a9.34,9.34,0,0,1-1.7,1.49,5.83,5.83,0,0,1-1.38.69,3.69,3.69,0,0,1-.94.19A2,2,0,0,1,674.13,350.57Z"/>
                        <g class="cls-107">
                            <path class="cls-108" d="M674.13,350.57l4.34,2.17a2,2,0,0,0,.36,0,3.6,3.6,0,0,0,.87-.16A5.27,5.27,0,0,0,681,352a8.23,8.23,0,0,0,1.56-1.31l2.07-2.2,3.77-4,3.84-4.09,2-2.15-2.8-4.25-2.23,2.47-4.24,4.68-4.15,4.58-2.27,2.49a9.34,9.34,0,0,1-1.7,1.49,5.83,5.83,0,0,1-1.38.69,3.69,3.69,0,0,1-.94.19,2,2,0,0,1-.39,0Z"/>
                        </g>
                        <path class="cls-109" d="M699.45,318a8.09,8.09,0,0,0,.51-1.17,6.51,6.51,0,0,0,.28-1.13,5.34,5.34,0,0,0,.06-1.07,4.61,4.61,0,0,0-.16-1l1.85,6.68a4.17,4.17,0,0,1,.14.89,4.8,4.8,0,0,1,0,1,5.73,5.73,0,0,1-.25,1,6.73,6.73,0,0,1-.45,1l-7.17,14-2.8-4.25Z"/>
                        <path class="cls-110" d="M656.13,320a7.93,7.93,0,0,1,1-1.5,7.39,7.39,0,0,1,1.32-1.21,5.25,5.25,0,0,1,1.49-.74l.48-.14-2.77,13.51,1.86,8.25L657,347.37a1.06,1.06,0,0,1-.25-.1,2,2,0,0,1-.51-.4,3.2,3.2,0,0,1-.57-.87,5.92,5.92,0,0,1-.44-1.51c0-.27-.19-1.14-.37-2.3l-.64-4-.6-3.73-.3-1.85,2.18-11A6.42,6.42,0,0,1,656.13,320Z"/>
                        <path class="cls-111" d="M674.15,335.61a10.89,10.89,0,0,1-3.11,1.83,7.43,7.43,0,0,1-3.17.49,5.15,5.15,0,0,1-4.33-2.9,7.12,7.12,0,0,1-.71-2.75,10.11,10.11,0,0,1,.37-3.27,13,13,0,0,1,1.41-3.28,13.65,13.65,0,0,1,2.21-2.77,11.85,11.85,0,0,1,2.79-2,8.52,8.52,0,0,1,3.13-.93,5.79,5.79,0,0,1,2.91.46,5.09,5.09,0,0,1,2.12,1.81,6.58,6.58,0,0,1,1,2.93,9.82,9.82,0,0,1-.32,3.72,13,13,0,0,1-1.7,3.73A13.42,13.42,0,0,1,674.15,335.61Z"/>
                        <path class="cls-112" d="M691.42,334l-2.23,2.47-4.24,4.68-4.15,4.58-2.27,2.49a9.34,9.34,0,0,1-1.7,1.49,5.83,5.83,0,0,1-1.38.69,3.69,3.69,0,0,1-.94.19,2,2,0,0,1-.39,0l3-10.9L686,330l9.95-19.21.76.09a4.33,4.33,0,0,1,2.08.75,3.6,3.6,0,0,1,1.25,1.6,4.6,4.6,0,0,1,.28,2.21,7,7,0,0,1-.82,2.56Z"/>
                        <path class="cls-113" d="M669.85,367.61l5.71,14.85,22.15,9.94-.54,2.62a4.78,4.78,0,0,1-.81,1.69,5,5,0,0,1-1.34,1.22,6,6,0,0,1-1.73.72,7.5,7.5,0,0,1-2,.21q-.44,0-.89-.07c-.3,0-.6-.09-.9-.16s-.61-.16-.91-.26-.61-.22-.92-.35l-19.47-9.77-5.33-16.72-.72.28,5.37,17,7.41,6.52a10.18,10.18,0,0,1,1.87,2.35,10.5,10.5,0,0,1,1.12,2.73,8.3,8.3,0,0,1,.24,2.74,5.35,5.35,0,0,1-.74,2.34l-1.83,3-15-16.49-3.66-12.44-3.26-13.19,6.39-28,16.4,1.47Z"/>
                        <path class="cls-81" d="M677.9,403.1a8.32,8.32,0,0,0-.24-2.74,10.5,10.5,0,0,0-1.12-2.74,10.17,10.17,0,0,0-1.87-2.34l-7.15-6.51,7.41,6.52a10.18,10.18,0,0,1,1.87,2.35,10.5,10.5,0,0,1,1.12,2.73,8.3,8.3,0,0,1,.24,2.74,5.35,5.35,0,0,1-.74,2.34l-1.83,3,1.57-3A5.37,5.37,0,0,0,677.9,403.1Z"/>
                        <polygon class="cls-82" points="697.71 392.4 675.29 382.59 669.58 367.77 676.42 339.77 669.85 367.61 675.55 382.47 697.71 392.4"/>
                        <polygon class="cls-83" points="691.52 333.83 694.16 338.12 691.34 334.07 691.52 333.83"/>
                        <path class="cls-114" d="M689,388.48l-13.42-6,4-2.53,6.47,2.92A10.29,10.29,0,0,1,689,388.48Z"/>
                        <path class="cls-85" d="M686.07,382.85a10.29,10.29,0,0,1,2.91,5.63L687.9,388A8.49,8.49,0,0,0,686.07,382.85Z"/>
                        <path class="cls-115" d="M699.45,318l-8,16-2.23,2.47-4.24,4.68-4.15,4.58-2.27,2.49a9.34,9.34,0,0,1-1.7,1.49,5.83,5.83,0,0,1-1.38.69,3.69,3.69,0,0,1-.94.19,2,2,0,0,1-.39,0l3-10.9L686,330l9.95-19.21.76.09a4.33,4.33,0,0,1,2.08.75,3.6,3.6,0,0,1,1.25,1.6,4.6,4.6,0,0,1,.28,2.21A7,7,0,0,1,699.45,318Z"/>
                        <path class="cls-116" d="M669.61,320.95a8.52,8.52,0,0,1,3.13-.93,5.79,5.79,0,0,1,2.91.46,5.09,5.09,0,0,1,2.12,1.81,6.58,6.58,0,0,1,1,2.93,9.82,9.82,0,0,1-.32,3.72,13,13,0,0,1-1.7,3.73,13.42,13.42,0,0,1-2.63,2.94,10.89,10.89,0,0,1-3.11,1.83,7.43,7.43,0,0,1-3.17.49,5.15,5.15,0,0,1-4.33-2.9,7.12,7.12,0,0,1-.71-2.75,10.11,10.11,0,0,1,.37-3.27,13,13,0,0,1,1.41-3.28,13.65,13.65,0,0,1,2.21-2.77A11.85,11.85,0,0,1,669.61,320.95Z"/>
                        <path class="cls-117" d="M660,338.3l16.4,1.47L672.35,357a60.8,60.8,0,0,1-9.55-7.4,28.13,28.13,0,0,1-4.17-5.21Z"/>
                        <path class="cls-118" d="M655.53,321.62a6.42,6.42,0,0,1,.61-1.65,7.93,7.93,0,0,1,1-1.5,7.39,7.39,0,0,1,1.32-1.21,5.25,5.25,0,0,1,1.49-.74l.48-.14-2.77,13.51,1.86,8.25-1.46,5.38a53.19,53.19,0,0,1-4.72-10.75l0-.1Z"/>
                        <path class="cls-119" d="M681.58,334.77,686,330l9.95-19.21.76.09a4.33,4.33,0,0,1,2.08.75,3.6,3.6,0,0,1,1.25,1.6,4.6,4.6,0,0,1,.28,2.21,7,7,0,0,1-.82,2.56l-8,16-1.48,1.63A27.38,27.38,0,0,1,681.58,334.77Z"/>
                        <path class="cls-120" d="M669.61,320.95a8.52,8.52,0,0,1,3.13-.93,5.79,5.79,0,0,1,2.91.46,5.09,5.09,0,0,1,2.12,1.81,6.58,6.58,0,0,1,1,2.93,9.82,9.82,0,0,1-.32,3.72,13,13,0,0,1-1.7,3.73l-.25.35c-5.2-2.15-9-4.91-11.23-8.3a13.58,13.58,0,0,1,1.53-1.76A11.85,11.85,0,0,1,669.61,320.95Z"/>
                        <path class="cls-55" d="M699.28,318a7,7,0,0,0,.82-2.56,4.78,4.78,0,0,0-.11-2.25,4.6,4.6,0,0,1,.28,2.21,7,7,0,0,1-.82,2.56l-8,16c-.16.17-1.06,1.08-2.27,2.42l-4.24,4.68-4.15,4.58-2.27,2.49c.26-.28,12.55-14.13,12.7-14.3Z"/>
                        <path class="cls-55" d="M665.18,336.94a5.28,5.28,0,0,0,2.63.91,7.42,7.42,0,0,0,3.17-.49,10.9,10.9,0,0,0,3.11-1.83,13.46,13.46,0,0,0,2.63-2.94,13,13,0,0,0,1.7-3.73,9.82,9.82,0,0,0,.33-3.72,6.58,6.58,0,0,0-1-2.93,5.38,5.38,0,0,0-.43-.56,5.4,5.4,0,0,1,.5.63,6.58,6.58,0,0,1,1,2.93,9.82,9.82,0,0,1-.32,3.72,13,13,0,0,1-1.7,3.73,13.42,13.42,0,0,1-2.63,2.94,10.89,10.89,0,0,1-3.11,1.83,7.43,7.43,0,0,1-3.17.49,5.29,5.29,0,0,1-2.63-.91,4.86,4.86,0,0,1-.57-.47A5,5,0,0,0,665.18,336.94Z"/>
                        <polygon class="cls-92" points="657.41 329.83 660.46 316.37 657.69 329.87 659.55 338.12 657.03 347.37 659.4 338.11 657.41 329.83"/>
                        <path class="cls-121" d="M666.59,385.83l.93,2.94,7.41,6.52a10.18,10.18,0,0,1,1.87,2.35,10.5,10.5,0,0,1,1.12,2.73,8.3,8.3,0,0,1,.24,2.74,5.35,5.35,0,0,1-.74,2.34l-1.83,3-15-16.49-1.36-4.63Q662.81,386.41,666.59,385.83Z"/>
                        <path class="cls-122" d="M667.4,385.71a87.59,87.59,0,0,1,12.4-.88h1.06l16.85,7.56-.54,2.62a4.78,4.78,0,0,1-.81,1.69,5,5,0,0,1-1.34,1.22,6,6,0,0,1-1.73.72,7.5,7.5,0,0,1-2,.21q-.44,0-.89-.07c-.3,0-.6-.09-.9-.16s-.61-.16-.91-.26-.61-.22-.92-.35l-19.47-9.77Z"/>
                    </g>
                    <g class="cls-123">
                        <polygon class="cls-124" points="606.46 340.05 613.31 344.94 614.77 327.59 610.25 321.57 606.46 340.05"/>
                        <g class="cls-125">
                            <path class="cls-62" d="M605.4,363.94l7.2,3,.06,0h.1l-7.2-3h-.1l-.06,0Z"/>
                        </g>
                        <polygon class="cls-126" points="605.55 364 612.75 366.95 615.88 355.41 609 351.34 605.55 364"/>
                        <polygon class="cls-127" points="609 351.34 615.88 355.41 613.31 344.94 606.46 340.05 609 351.34"/>
                        <path class="cls-8" d="M616.85,349.86l6.5,4.41a6.94,6.94,0,0,0,1.55.79,7.37,7.37,0,0,0,.88.26,8.22,8.22,0,0,0,.94.16,9.72,9.72,0,0,0,4.07-.49,13.31,13.31,0,0,0,4-2.16,15.88,15.88,0,0,0,3.31-3.55,15.17,15.17,0,0,0,2.12-4.55,13,13,0,0,0,.43-2.54,10.77,10.77,0,0,0-.1-2.34,9.1,9.1,0,0,0-.58-2.07,7.66,7.66,0,0,0-1-1.74l-5.27-6.77a7.91,7.91,0,0,1,1.07,1.87,9.56,9.56,0,0,1,.61,2.26,11.8,11.8,0,0,1,.08,2.58,14.73,14.73,0,0,1-.49,2.81,17.77,17.77,0,0,1-2.32,5.1,18.36,18.36,0,0,1-3.6,4,14.9,14.9,0,0,1-4.25,2.5,10.16,10.16,0,0,1-4.34.67,8.31,8.31,0,0,1-1-.14,7.67,7.67,0,0,1-.93-.25,7.28,7.28,0,0,1-.85-.36A7.06,7.06,0,0,1,616.85,349.86Z"/>
                        <g class="cls-128">
                            <path class="cls-129" d="M616.85,349.86l6.5,4.41a6.94,6.94,0,0,0,1.55.79,7.37,7.37,0,0,0,.88.26,8.22,8.22,0,0,0,.94.16,9.72,9.72,0,0,0,4.07-.49,13.31,13.31,0,0,0,4-2.16,15.88,15.88,0,0,0,3.31-3.55,15.17,15.17,0,0,0,2.12-4.55,13,13,0,0,0,.43-2.54,10.77,10.77,0,0,0-.1-2.34,9.1,9.1,0,0,0-.58-2.07,7.66,7.66,0,0,0-1-1.74l-5.27-6.77a7.91,7.91,0,0,1,1.07,1.87,9.56,9.56,0,0,1,.61,2.26,11.8,11.8,0,0,1,.08,2.58,14.73,14.73,0,0,1-.49,2.81,17.77,17.77,0,0,1-2.32,5.1,18.36,18.36,0,0,1-3.6,4,14.9,14.9,0,0,1-4.25,2.5,10.16,10.16,0,0,1-4.34.67,8.31,8.31,0,0,1-1-.14,7.67,7.67,0,0,1-.93-.25,7.28,7.28,0,0,1-.85-.36,7.06,7.06,0,0,1-.78-.46Z"/>
                        </g>
                        <polygon class="cls-67" points="612.57 397.43 619.73 395.51 620.66 395.15 613.55 397.05 612.57 397.43"/>
                        <polygon class="cls-130" points="619.91 420.63 626.65 416.29 619.73 395.51 612.57 397.43 619.91 420.63"/>
                        <polygon class="cls-131" points="623.09 391.69 629.64 390.23 637.66 358.07 632.08 353.6 623.09 391.69"/>
                        <polygon class="cls-132" points="630.9 412.01 636.42 408.54 629.64 390.23 623.09 391.69 630.9 412.01"/>
                        <path class="cls-133" d="M626.65,416.29l9.46,7.72a11.9,11.9,0,0,1,2.37,2.78,12.09,12.09,0,0,1,1.41,3.29,9.73,9.73,0,0,1,.3,3.33,6.59,6.59,0,0,1-.93,2.89L636.94,440l-6,7.49,2.51-4.06a7.32,7.32,0,0,0,1-3.2,11.36,11.36,0,0,0-.33-3.75,14.36,14.36,0,0,0-1.53-3.74,13.92,13.92,0,0,0-2.56-3.21l-10.14-8.93Z"/>
                        <polygon class="cls-134" points="661.21 425.6 661.88 420.02 636.42 408.54 630.9 412.01 661.21 425.6"/>
                        <path class="cls-73" d="M628.47,368.89l3.61-15.29,5.58,4.47-3.39,13.61Z"/>
                        <path class="cls-9" d="M629,368.37l5.93,3a2.68,2.68,0,0,0,.49,0,4.92,4.92,0,0,0,1.19-.22,7.2,7.2,0,0,0,1.73-.82,11.26,11.26,0,0,0,2.14-1.79l2.83-3,5.16-5.5,5.25-5.6,2.76-2.94-3.83-5.81L649.55,349l-5.8,6.41-5.68,6.26-3.1,3.41a12.78,12.78,0,0,1-2.33,2,8,8,0,0,1-1.88.94,5.05,5.05,0,0,1-1.28.26A2.75,2.75,0,0,1,629,368.37Z"/>
                        <g class="cls-135">
                            <path class="cls-136" d="M629,368.37l5.93,3a2.68,2.68,0,0,0,.49,0,4.92,4.92,0,0,0,1.19-.22,7.2,7.2,0,0,0,1.73-.82,11.26,11.26,0,0,0,2.14-1.79l2.83-3,5.16-5.5,5.25-5.6,2.76-2.94-3.83-5.81L649.55,349l-5.8,6.41-5.68,6.26-3.1,3.41a12.78,12.78,0,0,1-2.33,2,8,8,0,0,1-1.88.94,5.05,5.05,0,0,1-1.28.26,2.75,2.75,0,0,1-.53,0Z"/>
                        </g>
                        <path class="cls-137" d="M663.59,323.82a11.07,11.07,0,0,0,.69-1.59,8.91,8.91,0,0,0,.38-1.55,7.31,7.31,0,0,0,.08-1.46,6.31,6.31,0,0,0-.21-1.34l2.54,9.14a5.71,5.71,0,0,1,.19,1.21,6.57,6.57,0,0,1-.06,1.31,7.83,7.83,0,0,1-.34,1.37,9.21,9.21,0,0,1-.62,1.4l-9.81,19.18-3.83-5.81Z"/>
                        <path class="cls-138" d="M604.33,326.5a10.85,10.85,0,0,1,1.41-2.06,10.11,10.11,0,0,1,1.81-1.65,7.19,7.19,0,0,1,2-1l.66-.19-3.79,18.48L609,351.34,605.56,364a1.45,1.45,0,0,1-.34-.14,2.73,2.73,0,0,1-.7-.55,4.38,4.38,0,0,1-.78-1.19,8.1,8.1,0,0,1-.6-2.07c-.06-.37-.26-1.56-.51-3.15l-.88-5.41c-.3-1.88-.6-3.71-.82-5.11l-.41-2.53,3-15.09A8.78,8.78,0,0,1,604.33,326.5Z"/>
                        <path class="cls-139" d="M629,347.9a14.9,14.9,0,0,1-4.25,2.5,10.16,10.16,0,0,1-4.34.67,7,7,0,0,1-5.93-4,9.74,9.74,0,0,1-1-3.77,13.83,13.83,0,0,1,.5-4.48,17.72,17.72,0,0,1,1.93-4.49,18.67,18.67,0,0,1,3-3.78,16.22,16.22,0,0,1,3.81-2.74,11.66,11.66,0,0,1,4.29-1.27,7.91,7.91,0,0,1,4,.63,7,7,0,0,1,2.9,2.48,9,9,0,0,1,1.41,4,13.43,13.43,0,0,1-.44,5.09,17.77,17.77,0,0,1-2.32,5.1A18.36,18.36,0,0,1,629,347.9Z"/>
                        <path class="cls-140" d="M652.61,345.67,649.55,349l-5.8,6.41-5.68,6.26-3.1,3.41a12.78,12.78,0,0,1-2.33,2,8,8,0,0,1-1.88.94,5.05,5.05,0,0,1-1.28.26,2.75,2.75,0,0,1-.53,0L633,353.46l12.12-13.22L658.73,314l1,.12a5.92,5.92,0,0,1,2.85,1,4.93,4.93,0,0,1,1.72,2.19,6.29,6.29,0,0,1,.38,3,9.61,9.61,0,0,1-1.12,3.5Z"/>
                        <path class="cls-141" d="M623.09,391.69,630.9,412l30.31,13.59-.74,3.59a6.54,6.54,0,0,1-1.11,2.31,6.77,6.77,0,0,1-1.83,1.67,8.17,8.17,0,0,1-2.36,1,10.26,10.26,0,0,1-2.72.29q-.6,0-1.22-.09c-.41-.05-.82-.13-1.24-.22s-.83-.21-1.25-.35-.83-.3-1.25-.48l-26.64-13.37-7.29-22.88-1,.38,7.34,23.2,10.14,8.93a13.92,13.92,0,0,1,2.56,3.21,14.36,14.36,0,0,1,1.53,3.74,11.36,11.36,0,0,1,.33,3.75,7.32,7.32,0,0,1-1,3.2L631,447.51,610.37,425l-5-17-4.46-18,8.74-38.31,22.44,2Z"/>
                        <path class="cls-81" d="M634.1,440.24a11.38,11.38,0,0,0-.33-3.75,14.36,14.36,0,0,0-1.53-3.74,13.92,13.92,0,0,0-2.56-3.21l-9.78-8.91,10.14,8.93a13.92,13.92,0,0,1,2.56,3.21,14.36,14.36,0,0,1,1.53,3.74,11.36,11.36,0,0,1,.33,3.75,7.32,7.32,0,0,1-1,3.2L631,447.51l2.14-4.07A7.35,7.35,0,0,0,634.1,440.24Z"/>
                        <polygon class="cls-82" points="661.21 425.6 630.53 412.18 622.72 391.9 632.08 353.6 623.09 391.69 630.9 412.01 661.21 425.6"/>
                        <polygon class="cls-83" points="652.75 345.48 656.36 351.33 652.5 345.79 652.75 345.48"/>
                        <path class="cls-142" d="M649.26,420.24,630.9,412l5.53-3.46,8.86,4A14.08,14.08,0,0,1,649.26,420.24Z"/>
                        <path class="cls-85" d="M645.28,412.54a14.08,14.08,0,0,1,4,7.7l-1.47-.66C647.55,417.26,647.17,414.56,645.28,412.54Z"/>
                        <path class="cls-143" d="M663.59,323.82l-11,21.85L649.55,349l-5.8,6.41-5.68,6.26-3.1,3.41a12.78,12.78,0,0,1-2.33,2,8,8,0,0,1-1.88.94,5.05,5.05,0,0,1-1.28.26,2.75,2.75,0,0,1-.53,0L633,353.46l12.12-13.22L658.73,314l1,.12a5.92,5.92,0,0,1,2.85,1,4.93,4.93,0,0,1,1.72,2.19,6.29,6.29,0,0,1,.38,3A9.61,9.61,0,0,1,663.59,323.82Z"/>
                        <path class="cls-144" d="M622.77,327.85a11.66,11.66,0,0,1,4.29-1.27,7.91,7.91,0,0,1,4,.63,7,7,0,0,1,2.9,2.48,9,9,0,0,1,1.41,4,13.43,13.43,0,0,1-.44,5.09,17.77,17.77,0,0,1-2.32,5.1,18.36,18.36,0,0,1-3.6,4,14.9,14.9,0,0,1-4.25,2.5,10.16,10.16,0,0,1-4.34.67,7,7,0,0,1-5.93-4,9.74,9.74,0,0,1-1-3.77,13.83,13.83,0,0,1,.5-4.48,17.72,17.72,0,0,1,1.93-4.49,18.67,18.67,0,0,1,3-3.78A16.22,16.22,0,0,1,622.77,327.85Z"/>
                        <path class="cls-145" d="M609.64,351.59l22.44,2-5.56,23.56A83.18,83.18,0,0,1,613.45,367a38.48,38.48,0,0,1-5.71-7.13Z"/>
                        <path class="cls-146" d="M603.5,328.76a8.78,8.78,0,0,1,.83-2.26,10.85,10.85,0,0,1,1.41-2.06,10.11,10.11,0,0,1,1.81-1.65,7.19,7.19,0,0,1,2-1l.66-.19-3.79,18.48L609,351.34l-2,7.36A72.76,72.76,0,0,1,600.54,344l0-.14Z"/>
                        <path class="cls-147" d="M639.15,346.76l6-6.52L658.73,314l1,.12a5.92,5.92,0,0,1,2.85,1,4.93,4.93,0,0,1,1.72,2.19,6.29,6.29,0,0,1,.38,3,9.61,9.61,0,0,1-1.12,3.5l-11,21.85-2,2.23A37.45,37.45,0,0,1,639.15,346.76Z"/>
                        <path class="cls-148" d="M622.77,327.85a11.66,11.66,0,0,1,4.29-1.27,7.91,7.91,0,0,1,4,.63,7,7,0,0,1,2.9,2.48,9,9,0,0,1,1.41,4,13.43,13.43,0,0,1-.44,5.09,17.77,17.77,0,0,1-2.32,5.1c-.11.16-.23.32-.35.48-7.12-2.94-12.37-6.71-15.36-11.36a18.57,18.57,0,0,1,2.09-2.41A16.22,16.22,0,0,1,622.77,327.85Z"/>
                        <path class="cls-55" d="M663.36,323.87a9.61,9.61,0,0,0,1.12-3.5,6.54,6.54,0,0,0-.15-3.07,6.29,6.29,0,0,1,.38,3,9.61,9.61,0,0,1-1.12,3.5l-10.93,21.92c-.21.24-1.45,1.48-3.11,3.31l-5.8,6.41-5.68,6.26-3.1,3.41c.36-.39,17.17-19.33,17.38-19.57Z"/>
                        <path class="cls-55" d="M616.7,349.72a7.23,7.23,0,0,0,3.6,1.24,10.15,10.15,0,0,0,4.33-.67,14.92,14.92,0,0,0,4.25-2.5,18.41,18.41,0,0,0,3.6-4,17.77,17.77,0,0,0,2.32-5.1,13.44,13.44,0,0,0,.45-5.09,9,9,0,0,0-1.41-4,7.37,7.37,0,0,0-.59-.76,7.38,7.38,0,0,1,.69.86,9,9,0,0,1,1.41,4,13.43,13.43,0,0,1-.44,5.09,17.77,17.77,0,0,1-2.32,5.1,18.36,18.36,0,0,1-3.6,4,14.9,14.9,0,0,1-4.25,2.5,10.16,10.16,0,0,1-4.34.67,7.24,7.24,0,0,1-3.6-1.24,6.66,6.66,0,0,1-.79-.64A6.84,6.84,0,0,0,616.7,349.72Z"/>
                        <polygon class="cls-92" points="606.07 340 610.25 321.57 606.46 340.05 609 351.34 605.55 364 608.8 351.32 606.07 340"/>
                        <path class="cls-149" d="M618.64,416.61l1.27,4,10.14,8.93a13.92,13.92,0,0,1,2.56,3.21,14.36,14.36,0,0,1,1.53,3.74,11.36,11.36,0,0,1,.33,3.75,7.32,7.32,0,0,1-1,3.2L631,447.51,610.37,425l-1.87-6.33Q613.46,417.41,618.64,416.61Z"/>
                        <path class="cls-150" d="M619.74,416.45a119.84,119.84,0,0,1,17-1.2h1.45l23.06,10.34-.74,3.59a6.54,6.54,0,0,1-1.11,2.31,6.77,6.77,0,0,1-1.83,1.67,8.17,8.17,0,0,1-2.36,1,10.26,10.26,0,0,1-2.72.29q-.6,0-1.22-.09c-.41-.05-.82-.13-1.24-.22s-.83-.21-1.25-.35-.83-.3-1.25-.48l-26.64-13.37Z"/>
                    </g>
                    <g class="cls-person1">
                        <polygon class="cls-151" points="541.87 334.93 552.21 342.31 554.41 316.11 547.58 307.03 541.87 334.93"/>
                        <g class="cls-152">
                            <path class="cls-62" d="M540.26,371l10.87,4.46.09,0,.07,0h.08l-10.87-4.46h0l0,0-.07,0-.09,0Z"/>
                        </g>
                        <polygon class="cls-153" points="540.5 371.08 551.37 375.54 556.1 358.12 545.7 351.97 540.5 371.08"/>
                        <polygon class="cls-154" points="545.7 351.97 556.1 358.12 552.21 342.31 541.87 334.93 545.7 351.97"/>
                        <path class="cls-3" d="M557.55,349.74l9.81,6.66a10.48,10.48,0,0,0,2.33,1.19A11.13,11.13,0,0,0,571,358a12.42,12.42,0,0,0,1.42.24,14.67,14.67,0,0,0,6.14-.74,20.09,20.09,0,0,0,6-3.26,24,24,0,0,0,5-5.36,22.9,22.9,0,0,0,3.19-6.87,19.67,19.67,0,0,0,.65-3.83,16.26,16.26,0,0,0-.14-3.54,13.74,13.74,0,0,0-.88-3.13,11.57,11.57,0,0,0-1.53-2.63l-8-10.22a11.94,11.94,0,0,1,1.61,2.82,14.44,14.44,0,0,1,.92,3.41,17.82,17.82,0,0,1,.12,3.89,22.23,22.23,0,0,1-.74,4.25,26.83,26.83,0,0,1-3.51,7.7,27.72,27.72,0,0,1-5.43,6.08,22.5,22.5,0,0,1-6.41,3.78,15.34,15.34,0,0,1-6.55,1,12.54,12.54,0,0,1-1.51-.21A11.57,11.57,0,0,1,560,351a11,11,0,0,1-1.28-.54A10.66,10.66,0,0,1,557.55,349.74Z"/>
                        <g class="cls-155">
                            <path class="cls-156" d="M557.55,349.74l9.81,6.66a10.48,10.48,0,0,0,2.33,1.19A11.13,11.13,0,0,0,571,358a12.42,12.42,0,0,0,1.42.24,14.67,14.67,0,0,0,6.14-.74,20.09,20.09,0,0,0,6-3.26,24,24,0,0,0,5-5.36,22.9,22.9,0,0,0,3.19-6.87,19.67,19.67,0,0,0,.65-3.83,16.26,16.26,0,0,0-.14-3.54,13.74,13.74,0,0,0-.88-3.13,11.57,11.57,0,0,0-1.53-2.63l-8-10.22a11.94,11.94,0,0,1,1.61,2.82,14.44,14.44,0,0,1,.92,3.41,17.82,17.82,0,0,1,.12,3.89,22.23,22.23,0,0,1-.74,4.25,26.83,26.83,0,0,1-3.51,7.7,27.72,27.72,0,0,1-5.43,6.08,22.5,22.5,0,0,1-6.41,3.78,15.34,15.34,0,0,1-6.55,1,12.54,12.54,0,0,1-1.51-.21A11.57,11.57,0,0,1,560,351a11,11,0,0,1-1.28-.54,10.66,10.66,0,0,1-1.17-.69Z"/>
                        </g>
                        <polygon class="cls-67" points="551.09 421.56 561.9 418.65 563.32 418.12 552.58 420.99 551.09 421.56"/>
                        <polygon class="cls-157" points="562.17 456.59 572.35 450.03 561.9 418.65 551.09 421.56 562.17 456.59"/>
                        <polygon class="cls-158" points="566.98 412.89 576.87 410.68 588.98 362.13 580.55 355.38 566.98 412.89"/>
                        <polygon class="cls-159" points="578.76 443.57 587.11 438.34 576.87 410.68 566.98 412.89 578.76 443.57"/>
                        <path class="cls-160" d="M572.35,450l14.28,11.66a18,18,0,0,1,3.58,4.2,18.26,18.26,0,0,1,2.13,5,14.69,14.69,0,0,1,.45,5,10,10,0,0,1-1.4,4.37l-3.5,5.62-9,11.31,3.78-6.13a11.06,11.06,0,0,0,1.52-4.83,17.15,17.15,0,0,0-.49-5.66,21.68,21.68,0,0,0-2.31-5.65,21,21,0,0,0-3.87-4.84l-15.31-13.48Z"/>
                        <polygon class="cls-161" points="624.53 464.09 625.54 455.67 587.11 438.34 578.76 443.57 624.53 464.09"/>
                        <path class="cls-73" d="M575.1,378.47l5.45-23.09,8.43,6.75-5.12,20.55C582.49,382,577.26,379.5,575.1,378.47Z"/>
                        <path class="cls-4" d="M575.83,377.68l9,4.49a4.05,4.05,0,0,0,.74,0,7.43,7.43,0,0,0,1.79-.33,10.88,10.88,0,0,0,2.62-1.23,17,17,0,0,0,3.23-2.7l4.28-4.54,7.79-8.3,7.93-8.45,4.16-4.43-5.79-8.78-4.61,5.1-8.76,9.67-8.57,9.46-4.68,5.15a19.29,19.29,0,0,1-3.51,3.07,12,12,0,0,1-2.84,1.42,7.63,7.63,0,0,1-1.93.4A4.15,4.15,0,0,1,575.83,377.68Z"/>
                        <g class="cls-162">
                            <path class="cls-163" d="M575.83,377.68l9,4.49a4.05,4.05,0,0,0,.74,0,7.43,7.43,0,0,0,1.79-.33,10.88,10.88,0,0,0,2.62-1.23,17,17,0,0,0,3.23-2.7l4.28-4.54,7.79-8.3,7.93-8.45,4.16-4.43-5.79-8.78-4.61,5.1-8.76,9.67-8.57,9.46-4.68,5.15a19.29,19.29,0,0,1-3.51,3.07,12,12,0,0,1-2.84,1.42,7.63,7.63,0,0,1-1.93.4,4.15,4.15,0,0,1-.8,0Z"/>
                        </g>
                        <path class="cls-164" d="M628.12,310.43a16.71,16.71,0,0,0,1-2.41,13.46,13.46,0,0,0,.57-2.33,11,11,0,0,0,.12-2.2,9.53,9.53,0,0,0-.32-2l3.83,13.8a8.62,8.62,0,0,1,.29,1.83,9.92,9.92,0,0,1-.1,2,11.83,11.83,0,0,1-.51,2.07,13.91,13.91,0,0,1-.93,2.11l-14.81,29-5.79-8.78Z"/>
                        <path class="cls-165" d="M538.65,314.46a16.38,16.38,0,0,1,2.12-3.11,15.26,15.26,0,0,1,2.73-2.49,10.85,10.85,0,0,1,3.09-1.54l1-.29-5.72,27.9,3.84,17-5.2,19.11a2.19,2.19,0,0,1-.52-.21,4.12,4.12,0,0,1-1.06-.83,6.61,6.61,0,0,1-1.18-1.8,12.22,12.22,0,0,1-.91-3.12c-.09-.55-.39-2.36-.77-4.75s-.86-5.31-1.32-8.17-.9-5.6-1.24-7.71l-.61-3.82,4.51-22.78A13.26,13.26,0,0,1,538.65,314.46Z"/>
                        <path class="cls-166" d="M575.87,346.77a22.5,22.5,0,0,1-6.41,3.78,15.34,15.34,0,0,1-6.55,1,10.64,10.64,0,0,1-8.95-6,14.7,14.7,0,0,1-1.46-5.69,20.88,20.88,0,0,1,.76-6.76,26.76,26.76,0,0,1,2.92-6.77,28.19,28.19,0,0,1,4.56-5.71,24.49,24.49,0,0,1,5.76-4.14,17.61,17.61,0,0,1,6.47-1.92,12,12,0,0,1,6,1,10.51,10.51,0,0,1,4.37,3.74,13.59,13.59,0,0,1,2.13,6,20.28,20.28,0,0,1-.67,7.69,26.83,26.83,0,0,1-3.51,7.7A27.72,27.72,0,0,1,575.87,346.77Z"/>
                        <path class="cls-167" d="M611.54,343.42l-4.61,5.1-8.76,9.67-8.57,9.46-4.68,5.15a19.29,19.29,0,0,1-3.51,3.07,12,12,0,0,1-2.84,1.42,7.63,7.63,0,0,1-1.93.4,4.15,4.15,0,0,1-.8,0l6.12-22.51,18.3-20,20.54-39.67,1.56.18a8.93,8.93,0,0,1,4.3,1.56,7.44,7.44,0,0,1,2.59,3.3,9.5,9.5,0,0,1,.57,4.57,14.5,14.5,0,0,1-1.69,5.28Z"/>
                        <path class="cls-168" d="M567,412.89l11.79,30.68,45.76,20.52-1.12,5.42a9.87,9.87,0,0,1-1.67,3.49,10.22,10.22,0,0,1-2.76,2.52A12.34,12.34,0,0,1,615.4,477a15.5,15.5,0,0,1-4.11.43q-.9,0-1.84-.14c-.62-.08-1.24-.19-1.87-.33s-1.26-.32-1.89-.53-1.26-.45-1.89-.73l-40.22-20.19-11-34.54-1.49.58,11.08,35,15.31,13.48a21,21,0,0,1,3.87,4.84,21.68,21.68,0,0,1,2.31,5.65,17.15,17.15,0,0,1,.49,5.66,11.06,11.06,0,0,1-1.52,4.83l-3.78,6.13-31.08-34.05-7.57-25.7-6.73-27.24,13.2-57.84,33.87,3Z"/>
                        <path class="cls-81" d="M583.61,486.19a17.18,17.18,0,0,0-.49-5.66,21.68,21.68,0,0,0-2.31-5.65,21,21,0,0,0-3.87-4.84l-14.76-13.46,15.31,13.48a21,21,0,0,1,3.87,4.84,21.68,21.68,0,0,1,2.31,5.65,17.15,17.15,0,0,1,.49,5.66,11.06,11.06,0,0,1-1.52,4.83l-3.78,6.13,3.24-6.15A11.09,11.09,0,0,0,583.61,486.19Z"/>
                        <polygon class="cls-82" points="624.53 464.09 578.22 443.83 566.42 413.21 580.55 355.38 566.98 412.89 578.76 443.57 624.53 464.09"/>
                        <polygon class="cls-83" points="611.75 343.12 617.2 351.96 611.38 343.6 611.75 343.12"/>
                        <path class="cls-169" d="M606.48,456l-27.72-12.43,8.34-5.23,13.37,6C603.91,448.05,606,452.14,606.48,456Z"/>
                        <path class="cls-85" d="M600.48,444.37c3.43,3.68,5.56,7.77,6,11.63l-2.21-1C603.9,451.5,603.33,447.42,600.48,444.37Z"/>
                        <path class="cls-170" d="M628.12,310.43l-16.59,33-4.61,5.1-8.76,9.67-8.57,9.46-4.68,5.15a19.29,19.29,0,0,1-3.51,3.07,12,12,0,0,1-2.84,1.42,7.63,7.63,0,0,1-1.93.4,4.15,4.15,0,0,1-.8,0l6.12-22.51,18.3-20,20.54-39.67,1.56.18a8.93,8.93,0,0,1,4.3,1.56,7.44,7.44,0,0,1,2.59,3.3,9.5,9.5,0,0,1,.57,4.57A14.5,14.5,0,0,1,628.12,310.43Z"/>
                        <path class="cls-171" d="M566.5,316.5a17.61,17.61,0,0,1,6.47-1.92,12,12,0,0,1,6,1,10.51,10.51,0,0,1,4.37,3.74,13.59,13.59,0,0,1,2.13,6,20.28,20.28,0,0,1-.67,7.69,26.83,26.83,0,0,1-3.51,7.7,27.72,27.72,0,0,1-5.43,6.08,22.5,22.5,0,0,1-6.41,3.78,15.34,15.34,0,0,1-6.55,1,10.64,10.64,0,0,1-8.95-6,14.7,14.7,0,0,1-1.46-5.69,20.88,20.88,0,0,1,.76-6.76,26.76,26.76,0,0,1,2.92-6.77,28.19,28.19,0,0,1,4.56-5.71A24.49,24.49,0,0,1,566.5,316.5Z"/>
                        <path class="cls-172" d="M546.67,352.34l33.87,3L572.15,391a125.59,125.59,0,0,1-19.73-15.28,58.1,58.1,0,0,1-8.62-10.76Z"/>
                        <path class="cls-173" d="M537.4,317.88a13.26,13.26,0,0,1,1.25-3.42,16.38,16.38,0,0,1,2.12-3.11,15.26,15.26,0,0,1,2.73-2.49,10.85,10.85,0,0,1,3.09-1.54l1-.29-5.72,27.9,3.84,17-3,11.12a109.86,109.86,0,0,1-9.75-22.21c0-.09,0-.17,0-.21Z"/>
                        <path class="cls-174" d="M591.22,345.05l9-9.85,20.54-39.67,1.56.18a8.93,8.93,0,0,1,4.3,1.56,7.44,7.44,0,0,1,2.59,3.3,9.5,9.5,0,0,1,.57,4.57,14.5,14.5,0,0,1-1.69,5.28l-16.59,33-3,3.37A56.55,56.55,0,0,1,591.22,345.05Z"/>
                        <path class="cls-175" d="M566.5,316.5a17.61,17.61,0,0,1,6.47-1.92,12,12,0,0,1,6,1,10.51,10.51,0,0,1,4.37,3.74,13.59,13.59,0,0,1,2.13,6,20.28,20.28,0,0,1-.67,7.69,26.83,26.83,0,0,1-3.51,7.7c-.16.25-.35.48-.52.73C570,337,562.1,331.29,557.59,324.28a28,28,0,0,1,3.16-3.63A24.49,24.49,0,0,1,566.5,316.5Z"/>
                        <path class="cls-55" d="M627.78,310.49a14.51,14.51,0,0,0,1.69-5.28,9.88,9.88,0,0,0-.23-4.64,9.5,9.5,0,0,1,.57,4.57,14.5,14.5,0,0,1-1.69,5.28l-16.51,33.09c-.32.36-2.19,2.23-4.69,5l-8.76,9.67-8.57,9.46-4.68,5.15c.54-.59,25.92-29.19,26.24-29.55Z"/>
                        <path class="cls-55" d="M557.33,349.53a10.91,10.91,0,0,0,5.44,1.88,15.33,15.33,0,0,0,6.54-1,22.52,22.52,0,0,0,6.42-3.78,27.79,27.79,0,0,0,5.43-6.08,26.84,26.84,0,0,0,3.51-7.7,20.29,20.29,0,0,0,.67-7.69,13.59,13.59,0,0,0-2.13-6,11.12,11.12,0,0,0-.89-1.15,11.15,11.15,0,0,1,1,1.31,13.59,13.59,0,0,1,2.13,6,20.28,20.28,0,0,1-.67,7.69,26.83,26.83,0,0,1-3.51,7.7,27.72,27.72,0,0,1-5.43,6.08,22.5,22.5,0,0,1-6.41,3.78,15.34,15.34,0,0,1-6.55,1,10.93,10.93,0,0,1-5.43-1.88,10,10,0,0,1-1.19-1A10.33,10.33,0,0,0,557.33,349.53Z"/>
                        <polygon class="cls-92" points="541.28 334.85 547.58 307.03 541.87 334.93 545.7 351.97 540.5 371.08 545.41 351.94 541.28 334.85"/>
                        <path class="cls-176" d="M560.25,450.52l1.92,6.07,15.31,13.48a21,21,0,0,1,3.87,4.84,21.68,21.68,0,0,1,2.31,5.65,17.15,17.15,0,0,1,.49,5.66,11.06,11.06,0,0,1-1.52,4.83l-3.78,6.13-31.08-34.05L545,453.56Q552.44,451.72,560.25,450.52Z"/>
                        <path class="cls-177" d="M561.91,450.27a180.93,180.93,0,0,1,25.62-1.81l2.18,0,34.81,15.61-1.12,5.42a9.87,9.87,0,0,1-1.67,3.49,10.22,10.22,0,0,1-2.76,2.52A12.34,12.34,0,0,1,615.4,477a15.5,15.5,0,0,1-4.11.43q-.9,0-1.84-.14c-.62-.08-1.24-.19-1.87-.33s-1.26-.32-1.89-.53-1.26-.45-1.89-.73l-40.22-20.19Z"/>
                    </g>
                    <g class="cls-178">
                        <path class="cls-179 cls-avatar" d="M248.39,30.39c0,12-9,20.37-20.16,18.64S208,36.16,208,24.14,217,3.77,228.17,5.5,248.37,18.37,248.39,30.39Z"/>
                        <path class="cls-43 cls-avatar" d="M237.64,23c0,5.4-4.14,9.14-9.27,8.35s-9.29-5.82-9.3-11.22,4.14-9.14,9.27-8.35S237.63,17.63,237.64,23Z"/>
                        <path class="cls-43 cls-avatar" d="M223.69,31.17s-4.24,4.92-5.11,9.25A16.58,16.58,0,0,0,228,45.86c7.61,1.18,11.12-2.74,11.12-2.74s-2.5-6.92-5.87-10.48C233.21,32.65,229.7,35.45,223.69,31.17Z"/>
                        <line class="cls-183" x1="227.39" y1="48.96" x2="227.39" y2="105.96"/>
                        <path class="cls-181 cls-avatar" d="M252.87,30.82c-.47,14.57-11.81,24.63-25.34,22.46S203.43,37.53,203.9,23,215.72-1.67,229.24.5,253.35,16.24,252.87,30.82Z"/>
                    </g>
                    <g class="cls-213">
                        <path class="cls-182 cls-avatar" d="M708.39,150.77c0,7.93-5.94,13.43-13.29,12.29s-13.33-8.49-13.34-16.42,5.94-13.43,13.29-12.29S708.38,142.84,708.39,150.77Z"/>
                        <path class="cls-43 cls-avatar" d="M701.3,145.91a5.25,5.25,0,0,1-6.11,5.51A7.64,7.64,0,0,1,689,144a5.25,5.25,0,0,1,6.11-5.51A7.64,7.64,0,0,1,701.3,145.91Z"/>
                        <path class="cls-43 cls-avatar" d="M692.1,151.28s-2.79,3.25-3.37,6.1a10.93,10.93,0,0,0,6.18,3.59c5,.78,7.33-1.81,7.33-1.81s-1.65-4.57-3.87-6.91C698.38,152.25,696.06,154.1,692.1,151.28Z"/>
                        <polyline class="cls-183" points="601.94 255.11 694.94 279.11 694.94 163.62"/>
                        <path class="cls-184 cls-avatar" d="M712.3,151.47c-.33,10.24-8.3,17.31-17.81,15.78s-16.94-11.06-16.61-21.3,8.3-17.31,17.81-15.78S712.63,141.23,712.3,151.47Z"/>
                    </g>
                    <g class="cls-213">
                        <path class="cls-185 cls-avatar" d="M127.28,74.9c0,8.11-6.07,13.74-13.59,12.57S100.06,78.79,100,70.68s6.07-13.74,13.59-12.57S127.27,66.79,127.28,74.9Z"/>
                        <path class="cls-43 cls-avatar" d="M120,69.93a5.37,5.37,0,0,1-6.25,5.63A7.81,7.81,0,0,1,107.5,68a5.37,5.37,0,0,1,6.25-5.63A7.81,7.81,0,0,1,120,69.93Z"/>
                        <path class="cls-43 cls-avatar" d="M110.62,75.42s-2.86,3.32-3.44,6.24a11.18,11.18,0,0,0,6.32,3.67c5.13.79,7.5-1.85,7.5-1.85s-1.68-4.67-4-7.06C117,76.42,114.67,78.31,110.62,75.42Z"/>
                        <polyline class="cls-183" points="160.97 147.12 112.97 136.62 112.97 87.12"/>
                        <path class="cls-186 cls-avatar" d="M131.13,75.2c-.33,10.09-8.18,17.05-17.55,15.55s-16.69-10.9-16.37-21,8.18-17.05,17.55-15.55S131.46,65.11,131.13,75.2Z"/>
                    </g>
                    <g class="cls-213">
                        <path class="cls-179 cls-avatar" d="M743.43,476.75c0,12-9,20.37-20.16,18.64S703.07,482.52,703,470.5s9-20.37,20.16-18.64S743.41,464.73,743.43,476.75Z"/>
                        <path class="cls-43 cls-avatar" d="M732.68,469.39c0,5.4-4.14,9.14-9.27,8.35s-9.29-5.82-9.3-11.22,4.14-9.14,9.27-8.35S732.67,464,732.68,469.39Z"/>
                        <path class="cls-43 cls-avatar" d="M718.73,477.53s-4.24,4.92-5.11,9.25a16.58,16.58,0,0,0,9.37,5.44c7.61,1.18,11.12-2.74,11.12-2.74s-2.5-6.92-5.87-10.48C728.24,479,724.74,481.81,718.73,477.53Z"/>
                        <polyline class="cls-183" points="601.94 558.1 723.44 595.6 723.44 495.1"/>
                        <path class="cls-187 cls-avatar" d="M748.17,477c-.48,14.88-12.07,25.15-25.88,22.94s-24.62-16.08-24.14-31S710.22,443.79,724,446,748.65,462.09,748.17,477Z"/>
                    </g>
                    <path class="cls-179 cls-avatar" d="M126.43,534.75c0,12-9,20.37-20.16,18.64S86.07,540.52,86,528.5s9-20.37,20.16-18.64S126.41,522.73,126.43,534.75Z"/>
                    <path class="cls-43 cls-avatar" d="M115.68,527.39c0,5.4-4.14,9.14-9.27,8.35s-9.29-5.82-9.3-11.22,4.14-9.14,9.27-8.35S115.67,522,115.68,527.39Z"/>
                    <path class="cls-43 cls-avatar" d="M101.73,535.53s-4.24,4.92-5.11,9.25a16.58,16.58,0,0,0,9.37,5.44c7.61,1.18,11.12-2.74,11.12-2.74s-2.5-6.92-5.87-10.48C111.24,537,107.74,539.81,101.73,535.53Z"/>
                    <polyline class="cls-183" points="205.96 522.1 205.96 562.6 126.47 538.6"/>
                    <path class="cls-188 cls-avatar" d="M132.11,535.65c-.49,15.09-12.23,25.5-26.23,23.25s-25-16.3-24.47-31.39,12.23-25.5,26.23-23.25S132.6,520.56,132.11,535.65Z"/>
                    <g class="cls-189">
                        <path class="cls-190 cls-avatar" d="M781,410.61c0,8.93-6.69,15.12-15,13.84s-15-9.56-15-18.49,6.69-15.12,15-13.84S781,401.68,781,410.61Z"/>
                        <path class="cls-43 cls-avatar" d="M773,405.15c0,4-3.08,6.79-6.88,6.2a8.6,8.6,0,0,1-6.91-8.33c0-4,3.08-6.79,6.88-6.2A8.6,8.6,0,0,1,773,405.15Z"/>
                        <path class="cls-43 cls-avatar" d="M762.69,411.19s-3.15,3.66-3.79,6.87a12.31,12.31,0,0,0,7,4c5.65.88,8.26-2,8.26-2s-1.86-5.14-4.36-7.78C769.76,412.28,767.15,414.36,762.69,411.19Z"/>
                        <polyline class="cls-183" points="601.94 511.6 766.93 559.6 766.93 424.61"/>
                        <path class="cls-191 cls-avatar" d="M786,411.69c-.37,11.54-9.35,19.5-20.06,17.78s-19.08-12.46-18.71-24,9.35-19.5,20.06-17.78S786.37,400.15,786,411.69Z"/>
                    </g>
                    <g class="cls-192">
                        <path class="cls-193 cls-avatar" d="M29.43,411.81c0,7.74-5.8,13.12-13,12s-13-8.29-13-16,5.8-13.12,13-12S29.42,404.07,29.43,411.81Z"/>
                        <path class="cls-43 cls-avatar" d="M22.5,407.07a5.12,5.12,0,0,1-6,5.38,7.45,7.45,0,0,1-6-7.23,5.12,5.12,0,0,1,6-5.38A7.45,7.45,0,0,1,22.5,407.07Z"/>
                        <path class="cls-43 cls-avatar" d="M13.53,412.31s-2.73,3.17-3.29,6a10.67,10.67,0,0,0,6,3.5c4.9.76,7.16-1.77,7.16-1.77s-1.61-4.46-3.78-6.75C19.65,413.26,17.39,415.06,13.53,412.31Z"/>
                        <polyline class="cls-183" points="160.97 396.11 16.97 357.11 16.97 396.11"/>
                        <path class="cls-194 cls-avatar" d="M33.32,412.44c-.32,9.87-8,16.68-17.16,15.21S-.17,417,.15,407.11s8-16.68,17.16-15.21S33.63,402.57,33.32,412.44Z"/>
                    </g>
                    <path class="cls-195 cls-avatar" d="M582.39,84.33c0,14.59-10.93,24.72-24.46,22.62s-24.52-15.62-24.54-30.21S544.32,52,557.85,54.12,582.37,69.74,582.39,84.33Z"/>
                    <path class="cls-43 cls-avatar" d="M569.34,75.4c0,6.56-5,11.09-11.25,10.13s-11.28-7.06-11.29-13.62,5-11.09,11.25-10.13S569.33,68.84,569.34,75.4Z"/>
                    <path class="cls-43 cls-avatar" d="M552.42,85.27s-5.14,6-6.2,11.23c0,0,4.45,5.53,11.38,6.6,9.24,1.43,13.49-3.33,13.49-3.33s-3-8.4-7.12-12.71C564,87.06,559.71,90.47,552.42,85.27Z"/>
                    <polyline class="cls-183" points="408.45 157.62 408.45 126.12 558.45 168.12 558.45 106.62"/>
                    <path class="cls-196 cls-avatar" d="M587.37,85.06c-.57,17.55-14.23,29.65-30.51,27s-29-19-28.46-36.5,14.23-29.65,30.51-27S587.94,67.52,587.37,85.06Z"/>
                    <g class="cls-197">
                        <path class="cls-198 cls-avatar" d="M651.11,569.49c0,16.53-12.38,28-27.71,25.63s-27.77-17.7-27.8-34.22,12.38-28,27.71-25.63S651.09,553,651.11,569.49Z"/>
                        <path class="cls-43 cls-avatar" d="M636.33,559.37c0,7.43-5.69,12.57-12.74,11.48s-12.77-8-12.79-15.43,5.69-12.57,12.74-11.48S636.32,551.94,636.33,559.37Z"/>
                        <path class="cls-43 cls-avatar" d="M617.16,570.56s-5.82,6.77-7,12.72c0,0,5,6.26,12.89,7.48,10.46,1.62,15.28-3.77,15.28-3.77s-3.43-9.52-8.07-14.4C630.24,572.58,625.42,576.44,617.16,570.56Z"/>
                        <polyline class="cls-183" points="496.95 603.1 496.95 622.6 624.44 661.59 624.44 595.6"/>
                        <path class="cls-199 cls-avatar" d="M657.62,569.87c-.65,20.07-16.28,33.92-34.9,30.93s-33.2-21.69-32.55-41.76,16.28-33.92,34.9-30.93S658.27,549.79,657.62,569.87Z"/>
                    </g>
                    <g class="cls-214">
                        <circle class="cls-200" cx="63.47" cy="162.78" r="6.56"/>
                        <circle class="cls-201" cx="63.6" cy="144.42" r="5.54"/>
                        <circle class="cls-201" cx="63.6" cy="181.18" r="5.54"/>
                        <circle class="cls-201" cx="79.18" cy="153.93" r="5.54"/>
                        <circle class="cls-201" cx="79.18" cy="170.83" r="5.54"/>
                        <circle class="cls-201" cx="47.43" cy="153.93" r="5.54"/>
                        <circle class="cls-201" cx="47.43" cy="170.83" r="5.54"/>
                        <circle class="cls-202" cx="63.31" cy="162.62" r="10.34"/>
                        <line class="cls-203" x1="63.31" y1="191.43" x2="63.31" y2="394.87"/>
                    </g>
                    <g class="cls-214">
                        <circle class="cls-204" cx="734.06" cy="254.23" r="4.76"/>
                        <circle class="cls-205" cx="734.15" cy="240.91" r="4.02"/>
                        <circle class="cls-205" cx="734.15" cy="267.58" r="4.02"/>
                        <circle class="cls-205" cx="745.46" cy="247.81" r="4.02"/>
                        <circle class="cls-205" cx="745.46" cy="260.07" r="4.02"/>
                        <circle class="cls-205" cx="722.42" cy="247.81" r="4.02"/>
                        <circle class="cls-205" cx="722.42" cy="260.07" r="4.02"/>
                        <circle class="cls-206" cx="733.94" cy="254.11" r="7.5"/>
                        <line class="cls-207" x1="733.94" y1="279.02" x2="733.94" y2="281.52"/>
                        <line class="cls-208" x1="733.94" y1="287.72" x2="733.94" y2="421.03"/>
                        <line class="cls-207" x1="733.94" y1="424.13" x2="733.94" y2="426.63"/>
                    </g>
                    <g class="cls-209">
                        <circle class="cls-16" cx="288.6" cy="101.26" r="5.5"/>
                        <circle class="cls-210" cx="288.46" cy="101.12" r="8.67"/>
                        <line class="cls-210" x1="288.71" y1="112.65" x2="288.71" y2="113.86"/>
                        <line class="cls-211" x1="288.71" y1="117.44" x2="288.71" y2="300.81"/>
                        <line class="cls-210" x1="288.71" y1="302.6" x2="288.71" y2="303.81"/>
                    </g>
                    <g class="cls-209">
                        <circle class="cls-212" cx="480.45" cy="534.6" r="8.18"/>
                        <line class="cls-17" x1="480.45" y1="547.23" x2="480.45" y2="619.73"/>
                    </g>
                </g>
            </g>
        </svg>
    </div>
</template>
<script>
  export default {
    data(){
      return {
        cls:''
      }
    },
    mounted(){
      setTimeout(()=>{
        this.cls = 'animation'
      },1500)
    }
  }
</script>
<style>
    .cls-1,.cls-12,.cls-13,.cls-17,.cls-179,.cls-18,.cls-180,.cls-181,.cls-182,.cls-183,.cls-184,.cls-185,.cls-186,.cls-187,.cls-188,.cls-190,.cls-191,.cls-193,.cls-194,.cls-195,.cls-196,.cls-198,.cls-199,.cls-200,.cls-201,.cls-202,.cls-203,.cls-204,.cls-205,.cls-206,.cls-207,.cls-208,.cls-210,.cls-211,.cls-41,.cls-44,.cls-46 {
        fill: none;
    }

    .cls-2 {
        fill: url(#New_Gradient_Swatch_23);
    }

    .cls-3 {
        fill: url(#New_Gradient_Swatch_23-2);
    }

    .cls-4 {
        fill: url(#New_Gradient_Swatch_23-3);
    }

    .cls-5 {
        fill: url(#New_Gradient_Swatch_23-4);
    }

    .cls-6 {
        fill: url(#New_Gradient_Swatch_23-5);
    }

    .cls-7 {
        fill: url(#New_Gradient_Swatch_23-6);
    }

    .cls-8 {
        fill: url(#New_Gradient_Swatch_23-7);
    }

    .cls-9 {
        fill: url(#New_Gradient_Swatch_23-8);
    }

    .cls-189 {
        opacity: 0.3;
    }

    .cls-10 {
        fill: url(#radial-gradient);
    }

    .cls-58 {
        opacity: 0.4;
    }

    .cls-12,.cls-13,.cls-17,.cls-179,.cls-18,.cls-180,.cls-182,.cls-183,.cls-185,.cls-190,.cls-193,.cls-195,.cls-198,.cls-200,.cls-201,.cls-202,.cls-203,.cls-204,.cls-205,.cls-206,.cls-207,.cls-208,.cls-210,.cls-211,.cls-41,.cls-44,.cls-46 {
        stroke-miterlimit: 10;
    }

    .cls-12 {
        stroke-width: 1.48px;
        stroke-dasharray: 2.96 4.44;
        stroke: url(#radial-gradient-2);
    }

    /*底部圈*/
    .cls-10{
        opacity: 0;
        transition: opacity 0.5s;
    }
    .cls-14 {
        opacity:0 ;
        transition: opacity 0.5s 0.3s;
        fill: url(#radial-gradient-4);
    }

    .animation .cls-10{
        opacity: 0.3;
    }

    .animation .cls-14{
        opacity: 0.23;
    }

    .cls-11{
        opacity: 0;
        stroke-dasharray: 100;
        stroke-dashoffset: 100;
        transition: opacity 0.5s;
    }

    @keyframes rotate{
        from{
            stroke-dashoffset: 100;
        }
        to{
            stroke-dashoffset: 0;
        }
    }
    @-webkit-keyframes rotate{
        from{
            stroke-dashoffset: 100;
        }
        to{
            stroke-dashoffset: 0;
        }
    }

    .cls-13 {
        stroke-width: 1.65px;
        opacity: 0.2;
        stroke-dasharray: 10000;
        stroke-dashoffset: 10000;
        transition: all 8s;
        stroke: url(#radial-gradient-3);
    }

    .animation .cls-13,
    .animation .cls-11{
        stroke-dashoffset: 0;
    }

    .animation .cls-11{
        opacity: 0.4;
        animation:rotate  3s linear infinite;
    }

    .cls-181,
    .cls-196,
    .cls-199,
    .cls-187,
    .cls-188{
        stroke-dasharray: 100;
        stroke-dashoffset: 100;
    }
    .animation .cls-181,
    .animation .cls-187,
    .animation .cls-196,
    .animation .cls-199,
    .animation .cls-188{
        animation:rotate  3s linear infinite;
    }

    .cls-40{
        opacity: 0.2;
    }



    .cls-15 {
        opacity: 0.73;
    }

    .cls-16 {
        fill: #24cfff;
    }

    .cls-17,.cls-18,.cls-200,.cls-201,.cls-202,.cls-203,.cls-204,.cls-205,.cls-206,.cls-207,.cls-208,.cls-210,.cls-211 {
        stroke: #24cfff;
    }

    .cls-17,.cls-18 {
        stroke-width: 0.5px;
    }

    .cls-18 {
        stroke-dasharray: 3.95 5.93;
    }

    .cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40 {
        fill: #5a9bff;
        opacity: 0;
        transition: opacity 0.3s;
    }

    .animation .cls-19 {
        opacity: 0;
        transition-delay: 3.19s;
    }

    .animation .cls-20 {
        opacity: 0.01;
        transition-delay: 3.18s;
    }

    .animation .cls-21 {
        opacity: 0.02;
        transition-delay: 3.17s;
    }

    .animation .cls-22 {
        opacity: 0.03;
        transition-delay: 3.16s;
    }

    .animation .cls-23 {
        opacity: 0.04;
        transition-delay: 3.15s;
    }

    .animation .cls-24 {
        opacity: 0.05;
        transition-delay: 3.14s;
    }

    .animation .cls-25 {
        opacity: 0.06;
        transition-delay: 3.13s;
    }

    .animation .cls-26 {
        opacity: 0.07;
        transition-delay: 3.12s;
    }

    .animation .cls-27 {
        opacity: 0.08;
        transition-delay: 3.11s;
    }

    .animation .cls-28 {
        opacity: 0.09;
        transition-delay: 3.1s;
    }

    .animation .cls-29 {
        opacity: 0.1;
        transition-delay: 3.09s;
    }

    .animation .cls-30 {
        opacity: 0.1;
        transition-delay: 3.08s;
    }

    .animation .cls-31 {
        opacity: 0.11;
        transition-delay: 3.07s;
    }

    .animation .cls-32 {
        opacity: 0.12;
        transition-delay: 3.06s;
    }

    .animation .cls-33 {
        opacity: 0.13;
        transition-delay: 3.05s;
    }

    .animation .cls-34 {
        opacity: 0.14;
        transition-delay: 3.04s
    }

    .animation .cls-35 {
        opacity: 0.15;
        transition-delay: 3.03s
    }

    .animation .cls-36 {
        opacity: 0.16;
        transition-delay: 3.02s
    }

    .animation .cls-37 {
        opacity: 0.17;
        transition-delay: 3.01s
    }

    .animation .cls-38 {
        opacity: 0.18;
        transition-delay: 3.0s
    }

    .animation .cls-39 {
        opacity: 0.19;
        transition-delay: 3.0s
    }

    .cls-179,.cls-180,.cls-181,.cls-182,.cls-183,.cls-184,.cls-185,.cls-186,.cls-187,.cls-188,.cls-190,.cls-191,.cls-193,.cls-194,.cls-195,.cls-196,.cls-198,.cls-199,.cls-41 {
        stroke: aqua;
    }



    .cls-42 {
        opacity: 0.11;
    }

    .cls-43 {
        fill: aqua;
    }

    .cls-44 {
        stroke-width: 2.02px;
        stroke-dasharray: 5.07 5.07;
        stroke: url(#未命名的渐变_33);
        transform: translate(114px, -30px);
        transition: transform 0.4s 2.96s;
    }


    .cls-209 {
        opacity: 0.58;
    }

    /* 小花*/
    .cls-214,
    .cls-209,
    .cls-15{
        transform: translate(0px, 30px);
        opacity: 0;
        transition: all 0.4s 1.6s;
    }

    .animation .cls-214,
    .animation .cls-15,
    .animation .cls-209{
        transform: translate(0px, 0);
        opacity: 1;
    }
    .cls-logo{
        opacity: 0;
        transition: transform 0.4s 2.6s,opacity 0.4s 2s;
    }

    /* 黄色蒙层 */
    .cls-45 {
        fill: #ffffbe;
        opacity: 0;
        transform: translate(80px, 0px);
        transition: transform 0.4s 2.6s,opacity 0.4s 1.6s;
    }
    .cls-53 {
        opacity: 0;
        transform: translate(82px, 10px);
        transition: transform 0.4s 2.6s,opacity 0.4s 1.8s;;
    }

    .cls-46-group{
        opacity: 0;
        transform: translate(70px, 25px);
        transition: transform 0.4s 2.6s,opacity 0.4s 2s;
    }

    .cls-47-group{
        opacity: 0;
        transform: translate(93px, 48px);
        transition: transform 0.4s 2.6s,opacity 0.4s 2.2s;
    }

    .animation .cls-45{
        opacity: 0.33;
        transform: translate(0, 0px);
    }
    .animation .cls-44{
        transform: translate(0, 0px);
    }
    .animation .cls-53{
        opacity: 0.59;
        transform: translate(0, 0px);
    }

    .animation .cls-46-group,
    .animation .cls-logo,
    .animation .cls-47-group{
        opacity: 1;
        transform: translate(0, 0px);
    }



    .cls-46 {
        stroke: #d2825c;
        stroke-width: 0.63px;
    }

    .cls-47 {
        fill: url(#未命名的渐变_31);
    }

    .cls-48 {
        fill: url(#未命名的渐变_31-2);
    }

    .cls-49 {
        fill: url(#未命名的渐变_31-3);
    }

    .cls-50 {
        fill: url(#未命名的渐变_31-4);
    }

    .cls-51 {
        fill: url(#未命名的渐变_31-5);
    }

    .cls-52 {
        fill: url(#未命名的渐变_31-6);
    }


    .cls-54 {
        fill: url(#未命名的渐变_23);
    }

    .cls-55 {
        fill: #fff;
    }

    .cls-56 {
        fill: #0069dc;
        opacity: 0;
        transition: all 0.4s 2.6s;
    }

    .cls-57 {
        fill: #0098ff;
        opacity: 0.66;
        opacity:0;
        transition: all 0.4s 3s;
        transform: translate(0px, -25px);
    }

    .cls-58 {
        fill: #3fb7ff;
        transition: all 0.4s 3s;
        opacity: 0;
        transform: translate(0px, -50px);
    }

    .animation .cls-56{
        opacity: 0.78;
    }

    .animation .cls-57{
        opacity: 0.66;
        transform: translate(0px, 0);
    }

    .animation .cls-58{
        opacity: 0.4;
        transform: translate(0px, 0);
    }


    .cls-60 {
        fill: url(#New_Gradient_Swatch_23-9);
    }

    .cls-61 {
        clip-path: url(#clip-path);
    }

    .cls-62 {
        fill: #67bba8;
    }

    .cls-63 {
        fill: url(#New_Gradient_Swatch_23-10);
    }

    .cls-64 {
        fill: url(#New_Gradient_Swatch_23-11);
    }

    .cls-65 {
        clip-path: url(#clip-path-2);
    }

    .cls-66 {
        fill: url(#New_Gradient_Swatch_23-13);
    }

    .cls-67 {
        fill: #31574a;
    }

    .cls-68 {
        fill: url(#New_Gradient_Swatch_23-14);
    }

    .cls-69 {
        fill: url(#New_Gradient_Swatch_23-15);
    }

    .cls-70 {
        fill: url(#New_Gradient_Swatch_23-16);
    }

    .cls-71 {
        fill: url(#New_Gradient_Swatch_23-17);
    }

    .cls-72 {
        fill: url(#New_Gradient_Swatch_23-18);
    }

    .cls-73 {
        fill: #005b4a;
    }

    .cls-74 {
        clip-path: url(#clip-path-3);
    }

    .cls-75 {
        fill: url(#New_Gradient_Swatch_23-20);
    }

    .cls-76 {
        fill: url(#New_Gradient_Swatch_23-21);
    }

    .cls-77 {
        fill: url(#New_Gradient_Swatch_15);
    }

    .cls-78 {
        fill: url(#New_Gradient_Swatch_15-2);
    }

    .cls-79 {
        fill: url(#New_Gradient_Swatch_15-3);
    }

    .cls-80 {
        fill: url(#New_Gradient_Swatch_15-4);
    }

    .cls-81 {
        fill: #adffe9;
    }

    .cls-82 {
        fill: #8effe1;
    }

    .cls-83 {
        fill: #27c09b;
    }

    .cls-84 {
        fill: url(#New_Gradient_Swatch_23-22);
    }

    .cls-85 {
        fill: #41ceab;
    }

    .cls-86 {
        fill: url(#New_Gradient_Swatch_15-5);
    }

    .cls-87 {
        fill: url(#New_Gradient_Swatch_15-6);
    }

    .cls-88 {
        fill: url(#New_Gradient_Swatch_15-7);
    }

    .cls-89 {
        fill: url(#New_Gradient_Swatch_15-8);
    }

    .cls-90 {
        fill: url(#New_Gradient_Swatch_15-9);
    }

    .cls-91 {
        fill: url(#New_Gradient_Swatch_15-10);
    }

    .cls-92 {
        fill: #c3fbed;
    }

    .cls-93 {
        fill: url(#New_Gradient_Swatch_15-11);
    }

    .cls-94 {
        fill: url(#New_Gradient_Swatch_15-12);
    }

    .cls-96 {
        fill: url(#New_Gradient_Swatch_23-23);
    }

    .cls-97 {
        clip-path: url(#clip-path-4);
    }

    .cls-98 {
        fill: url(#New_Gradient_Swatch_23-24);
    }

    .cls-99 {
        fill: url(#New_Gradient_Swatch_23-25);
    }

    .cls-100 {
        clip-path: url(#clip-path-5);
    }

    .cls-101 {
        fill: url(#New_Gradient_Swatch_23-27);
    }

    .cls-102 {
        fill: url(#New_Gradient_Swatch_23-28);
    }

    .cls-103 {
        fill: url(#New_Gradient_Swatch_23-29);
    }

    .cls-104 {
        fill: url(#New_Gradient_Swatch_23-30);
    }

    .cls-105 {
        fill: url(#New_Gradient_Swatch_23-31);
    }

    .cls-106 {
        fill: url(#New_Gradient_Swatch_23-32);
    }

    .cls-107 {
        clip-path: url(#clip-path-6);
    }

    .cls-108 {
        fill: url(#New_Gradient_Swatch_23-34);
    }

    .cls-109 {
        fill: url(#New_Gradient_Swatch_23-35);
    }

    .cls-110 {
        fill: url(#New_Gradient_Swatch_15-13);
    }

    .cls-111 {
        fill: url(#New_Gradient_Swatch_15-14);
    }

    .cls-112 {
        fill: url(#New_Gradient_Swatch_15-15);
    }

    .cls-113 {
        fill: url(#New_Gradient_Swatch_15-16);
    }

    .cls-114 {
        fill: url(#New_Gradient_Swatch_23-36);
    }

    .cls-115 {
        fill: url(#New_Gradient_Swatch_15-17);
    }

    .cls-116 {
        fill: url(#New_Gradient_Swatch_15-18);
    }

    .cls-117 {
        fill: url(#New_Gradient_Swatch_15-19);
    }

    .cls-118 {
        fill: url(#New_Gradient_Swatch_15-20);
    }

    .cls-119 {
        fill: url(#New_Gradient_Swatch_15-21);
    }

    .cls-120 {
        fill: url(#New_Gradient_Swatch_15-22);
    }

    .cls-121 {
        fill: url(#New_Gradient_Swatch_15-23);
    }

    .cls-122 {
        fill: url(#New_Gradient_Swatch_15-24);
    }
    .cls-person1{
        opacity: 0;
        transition: opacity 0.3s .2s;
    }

    .animation .cls-person1{
        opacity: 1;
    }

    /*第二小人*/
    .cls-123 {
        opacity: 0;
        transform: translate(-47px, 5px);
        transition: transform 0.4s .3s, opacity 0.3s .3s;
    }
    .animation .cls-123{
        opacity: 0.5;
        transform: translate(0, 0);
    }
    .cls-95{
        opacity: 0;
        transform: translate(-68px, 30px);
        transition: transform 0.4s .5s, opacity 0.3s .5s;
    }
    .animation .cls-95{
        opacity: 0.2;
        transform: translate(0, 0);
    }

    .cls-59 {
        opacity: 0;
        transform: translate(-68px, 30px);
        transition: transform 0.4s .8s, opacity 0.3s .8s;
    }

    .animation .cls-59{
        opacity: 0.05;
        transform: translate(0, 0);
    }

    .cls-124 {
        fill: url(#New_Gradient_Swatch_23-37);
    }

    .cls-125 {
        clip-path: url(#clip-path-7);
    }

    .cls-126 {
        fill: url(#New_Gradient_Swatch_23-38);
    }

    .cls-127 {
        fill: url(#New_Gradient_Swatch_23-39);
    }

    .cls-128 {
        clip-path: url(#clip-path-8);
    }

    .cls-129 {
        fill: url(#New_Gradient_Swatch_23-41);
    }

    .cls-130 {
        fill: url(#New_Gradient_Swatch_23-42);
    }

    .cls-131 {
        fill: url(#New_Gradient_Swatch_23-43);
    }

    .cls-132 {
        fill: url(#New_Gradient_Swatch_23-44);
    }

    .cls-133 {
        fill: url(#New_Gradient_Swatch_23-45);
    }

    .cls-134 {
        fill: url(#New_Gradient_Swatch_23-46);
    }

    .cls-135 {
        clip-path: url(#clip-path-9);
    }

    .cls-136 {
        fill: url(#New_Gradient_Swatch_23-48);
    }

    .cls-137 {
        fill: url(#New_Gradient_Swatch_23-49);
    }

    .cls-138 {
        fill: url(#New_Gradient_Swatch_15-25);
    }

    .cls-139 {
        fill: url(#New_Gradient_Swatch_15-26);
    }

    .cls-140 {
        fill: url(#New_Gradient_Swatch_15-27);
    }

    .cls-141 {
        fill: url(#New_Gradient_Swatch_15-28);
    }

    .cls-142 {
        fill: url(#New_Gradient_Swatch_23-50);
    }

    .cls-143 {
        fill: url(#New_Gradient_Swatch_15-29);
    }

    .cls-144 {
        fill: url(#New_Gradient_Swatch_15-30);
    }

    .cls-145 {
        fill: url(#New_Gradient_Swatch_15-31);
    }

    .cls-146 {
        fill: url(#New_Gradient_Swatch_15-32);
    }

    .cls-147 {
        fill: url(#New_Gradient_Swatch_15-33);
    }

    .cls-148 {
        fill: url(#New_Gradient_Swatch_15-34);
    }

    .cls-149 {
        fill: url(#New_Gradient_Swatch_15-35);
    }

    .cls-150 {
        fill: url(#New_Gradient_Swatch_15-36);
    }

    .cls-151 {
        fill: url(#New_Gradient_Swatch_23-51);
    }

    .cls-152 {
        clip-path: url(#clip-path-10);
    }

    .cls-153 {
        fill: url(#New_Gradient_Swatch_23-52);
    }

    .cls-154 {
        fill: url(#New_Gradient_Swatch_23-53);
    }

    .cls-155 {
        clip-path: url(#clip-path-11);
    }

    .cls-156 {
        fill: url(#New_Gradient_Swatch_23-55);
    }

    .cls-157 {
        fill: url(#New_Gradient_Swatch_23-56);
    }

    .cls-158 {
        fill: url(#New_Gradient_Swatch_23-57);
    }

    .cls-159 {
        fill: url(#New_Gradient_Swatch_23-58);
    }

    .cls-160 {
        fill: url(#New_Gradient_Swatch_23-59);
    }

    .cls-161 {
        fill: url(#New_Gradient_Swatch_23-60);
    }

    .cls-162 {
        clip-path: url(#clip-path-12);
    }

    .cls-163 {
        fill: url(#New_Gradient_Swatch_23-62);
    }

    .cls-164 {
        fill: url(#New_Gradient_Swatch_23-63);
    }

    .cls-165 {
        fill: url(#New_Gradient_Swatch_15-37);
    }

    .cls-166 {
        fill: url(#New_Gradient_Swatch_15-38);
    }

    .cls-167 {
        fill: url(#New_Gradient_Swatch_15-39);
    }

    .cls-168 {
        fill: url(#New_Gradient_Swatch_15-40);
    }

    .cls-169 {
        fill: url(#New_Gradient_Swatch_23-64);
    }

    .cls-170 {
        fill: url(#New_Gradient_Swatch_15-41);
    }

    .cls-171 {
        fill: url(#New_Gradient_Swatch_15-42);
    }

    .cls-172 {
        fill: url(#New_Gradient_Swatch_15-43);
    }

    .cls-173 {
        fill: url(#New_Gradient_Swatch_15-44);
    }

    .cls-174 {
        fill: url(#New_Gradient_Swatch_15-45);
    }

    .cls-175 {
        fill: url(#New_Gradient_Swatch_15-46);
    }

    .cls-176 {
        fill: url(#New_Gradient_Swatch_15-47);
    }

    .cls-177 {
        fill: url(#New_Gradient_Swatch_15-48);
    }

    .cls-178 {
        opacity: 0.9;
    }

    .cls-179 {
        stroke-width: 1.55px;
    }

    .cls-181,.cls-184,.cls-186,.cls-187,.cls-188,.cls-191,.cls-194,.cls-196,.cls-199 {
        stroke-linecap: round;
        stroke-linejoin: round;
    }

    .cls-181 {
        stroke-width: 0.41px;
        stroke-dasharray: 0.82 1.65;
    }

    .cls-182 {
        stroke-width: 1.03px;
    }
    /* line */
    .cls-183 {
        fill-rule: evenodd;
        stroke-dashoffset: 1000;
        stroke-dasharray: 1000;
        transition: all 3s 2.37s;
    }

    /* main line*/
    .cls-41 {
        stroke-width: 2.16px;
        opacity: 0.46;
        stroke-dashoffset: 10000;
        stroke-dasharray: 10000;
        transition: all 10s 0.67s;
    }

    .cls-41-line{
        opacity:0;
        transition: all .6s 2.37s;
    }

    .cls-avatar{
        opacity:0;
        transition: all .6s 3s;
    }

    .animation .cls-183,
    .animation .cls-41{
        stroke-dashoffset: 0;
    }

    .animation .cls-avatar,
    .animation .cls-41-line{
        opacity:1;
    }

    .cls-184 {
        stroke-width: 0.29px;
        stroke-dasharray: 0.58 1.16;
    }

    .cls-185 {
        stroke-width: 1.05px;
    }

    .cls-186 {
        stroke-width: 0.29px;
        stroke-dasharray: 0.57 1.14;
    }

    .cls-187 {
        stroke-width: 0.42px;
        stroke-dasharray: 0.84 1.68;
    }

    .cls-188 {
        stroke-width: 0.43px;
        stroke-dasharray: 0.85 1.71;
    }

    .cls-190 {
        stroke-width: 1.15px;
    }

    .cls-191 {
        stroke-width: 0.33px;
        stroke-dasharray: 0.65 1.3;
    }

    .cls-192 {
        opacity: 0.7;
    }

    .cls-193 {
        stroke-width: 1px;
    }

    .cls-194 {
        stroke-width: 0.28px;
        stroke-dasharray: 0.56 1.12;
    }

    .cls-195 {
        stroke-width: 1.89px;
    }

    .cls-196 {
        stroke-width: 0.5px;
        stroke-dasharray: 0.99 1.98;
    }

    .cls-197 {
        opacity: 0.8;
    }

    .cls-198 {
        stroke-width: 2.14px;
    }

    .cls-199 {
        stroke-width: 0.57px;
        stroke-dasharray: 1.14 2.27;
    }

    .cls-200 {
        stroke-width: 0.72px;
    }

    .cls-201 {
        stroke-width: 0.61px;
    }

    .cls-202 {
        stroke-width: 0.36px;
    }

    .cls-203 {
        stroke-width: 0.4px;
    }

    .cls-204 {
        stroke-width: 0.52px;
    }

    .cls-205 {
        stroke-width: 0.44px;
    }

    .cls-206 {
        stroke-width: 0.26px;
    }

    .cls-207,.cls-208 {
        stroke-width: 0.29px;
    }

    .cls-208 {
        stroke-dasharray: 5.17 6.2;
    }

    .cls-210,.cls-211 {
        stroke-width: 0.3px;
    }

    .cls-211 {
        stroke-dasharray: 2.39 3.58;
    }

    .cls-212 {
        fill: #00afff;
    }
</style>
